/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from "axios";

import { Expose, Transform, Type, plainToClass } from "class-transformer";

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(
    configs: IRequestConfig,
    resolve: (p: any) => void,
    reject: (p: any) => void
): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error("please inject yourself instance like axios  ");
    }
}

export function getConfigs(
    method: string,
    contentType: string,
    url: string,
    options: any
): IRequestConfig {
    const configs: IRequestConfig = { ...options, method, url };
    configs.headers = {
        ...options.headers,
        "Content-Type": contentType,
    };
    return configs;
}

export const basePath = "";

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class AutoFileService {
    /**
     *
     */
    static autoFile(
        params: {
            /** requestBody */
            body?: TopManualFilesRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<TopManualFilesListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/AutoFile";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            TopManualFilesListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static detail(
        params: {
            /** requestBody */
            body?: TopManualFilesByDocTypesRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<TopManualFilesByDocTypeListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/AutoFile/detail";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            TopManualFilesByDocTypeListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class BatchUploadService {
    /**
     *
     */
    static batchdropped(
        params: {
            /** requestBody */
            body?: BatchUploadRequests;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BatchUploadResponseDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/BatchUpload/batchdropped";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            BatchUploadResponseDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static badData(
        params: {
            /**  */
            uploaderId: string;
            /** requestBody */
            body?: EFileReportRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BatchUploadResponseListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/BatchUpload/bad_data/{uploaderID}";
            url = url.replace("{uploaderID}", params["uploaderId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            BatchUploadResponseListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class CaseDataDetailService {
    /**
     *
     */
    static submission(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: CaseDataRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseDataDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/CaseDataDetail/submission/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(CaseDataDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static originalNewSuit(
        params: {
            /**  */
            county?: string;
            /**  */
            caseNumber?: string;
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/CaseDataDetail/original-new-suit";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                county: params["county"],
                caseNumber: params["caseNumber"],
                attorneyId: params["attorneyId"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class CoversheetService {
    /**
     *
     */
    static addcoversheet(
        params: {
            /** requestBody */
            body?: CoversheetSave;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetSaveDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/addcoversheet";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CoversheetSaveDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static listcoversheet(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CoversheetSaveListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Coversheet/listcoversheet";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyID: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            CoversheetSaveListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class DataTracService {
    /**
     *
     */
    static reconcile(
        params: {
            /** requestBody */
            body?: DataTracReconcileRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DataTracReconcileResultDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/DataTrac/reconcile";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            DataTracReconcileResultDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class DocumentsService {
    /**
     *
     */
    static view(
        params: {
            /**  */
            submissionId: string;
            /**  */
            documentId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<string> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Documents/view/{submissionId}/{documentId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");
            url = url.replace("{documentId}", params["documentId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static page(
        params: {
            /**  */
            documentId: string;
            /**  */
            pageNumber: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<StringDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Documents/{documentId}/page/{pageNumber}";
            url = url.replace("{documentId}", params["documentId"] + "");
            url = url.replace("{pageNumber}", params["pageNumber"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(StringDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static insert(
        params: {
            /** requestBody */
            body?: Document;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/insert";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static remove(
        params: {
            /**  */
            documentId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/remove/{documentId}";
            url = url.replace("{documentId}", params["documentId"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static getByUcn(
        params: {
            /**  */
            ucn?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/getByUCN";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { ucn: params["ucn"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(DocumentListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static updateStatus(
        params: {
            /**  */
            referenceNumber?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/UpdateStatus";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { referenceNumber: params["referenceNumber"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static split(
        params: {
            /** requestBody */
            body?: SplitDocument;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/split";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static split1(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SplitDocumentDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/split/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SplitDocumentDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static downloadStampedPdf(
        params: {
            /**  */
            request?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/DownloadStampedPDF";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { request: params["request"] };
            let data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static stampedCopies(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            from?: string;
            /**  */
            till?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/StampedCopies/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { from: params["from"], till: params["till"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(DocumentListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static accepted(
        params: {
            /**  */
            documentId: string;
            /** requestBody */
            body?: AcceptedRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/accepted/{documentId}";
            url = url.replace("{documentId}", params["documentId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static rejected(
        params: {
            /**  */
            documentId: string;
            /** requestBody */
            body?: RejectedRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/rejected/{documentId}";
            url = url.replace("{documentId}", params["documentId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static documents(
        options: IRequestOptions = {}
    ): Promise<DocumentIEnumerableAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(DocumentIEnumerableAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static documents1(
        params: {
            /** requestBody */
            body?: Document;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static documents2(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static documents3(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: Document;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static documents4(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Documents/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocumentAPIResponse, response)),
                reject
            );
        });
    }
}

export class DownloadService {
    /**
     *
     */
    static download(
        params: {
            /**  */
            request?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<string> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Download";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { request: params["request"] };
            let data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}

export class EFileService {
    /**
     *
     */
    static eFile(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BeginUploadDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(BeginUploadDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static begin(
        params: {
            /**  */
            fileAsIndividuals?: boolean;
            /** requestBody */
            body?: any | null[];
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BeginUploadDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/begin";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { fileAsIndividuals: params["fileAsIndividuals"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(BeginUploadDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static existing(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: eFile;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/existing/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static previewexisting(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: eFile;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/previewexisting/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static previewNewcase(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: NewCase;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/previewNewcase/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static efilemycases(
        params: {
            /** requestBody */
            body?: eFile;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/efilemycases";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static order(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: Order;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/order/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static newCase(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: NewCase;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/newCase/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static batch(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: NewCase;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/batch/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static dfs(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: DFS;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/dfs/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static service(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: eFile;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/eFile/service/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static existing1(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: eFile;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/eFile/existing/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
}

export class EmailService {
    /**
     *
     */
    static emails(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Email/{id}/Emails";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static email(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: EmailRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Email/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static email1(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: EmailRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Email/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static email2(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: EmailRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Email/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailDetailedResponse, response)),
                reject
            );
        });
    }
}

export class EmailRecieptService {
    /**
     *
     */
    static resend(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailReceiptListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/EmailReciept/submission/{id}/resend";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(EmailReceiptListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static submission(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailReceiptListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/EmailReciept/submission/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(EmailReceiptListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static emailReciept(
        options: IRequestOptions = {}
    ): Promise<EmailReceiptIEnumerableAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/EmailReciept";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EmailReceiptIEnumerableAPIResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static emailReciept1(
        params: {
            /** requestBody */
            body?: EmailReceipt;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailReceiptAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/EmailReciept";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailReceiptAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static emailReciept2(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailReceiptAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/EmailReciept/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailReceiptAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static emailReciept3(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: EmailReceipt;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailReceiptAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/EmailReciept/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailReceiptAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static emailReciept4(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EmailReceiptAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/EmailReciept/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(EmailReceiptAPIResponse, response)),
                reject
            );
        });
    }
}

export class EnvelopeService {
    /**
     *
     */
    static existingCase(
        params: {
            /** requestBody */
            body?: CaseData;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Envelope/new/existingCase";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static newCase(
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Envelope/new/newCase";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorney(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Envelope/attorney/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static write(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Envelope/write";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static read(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Envelope/read/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static save(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Envelope/save";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
}

export class FeeCalculatorService {
    /**
     *
     */
    static existing(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FeeListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/FeeCalculator/existing";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(FeeListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static new(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FeeListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/FeeCalculator/new";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(FeeListDetailedResponse, response)),
                reject
            );
        });
    }
}

export class FileUploadService {
    /**
     *
     */
    static list(
        params: {
            /**  */
            route: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IFileInfoIEnumerableDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/FileUpload/list/{route}";
            url = url.replace("{route}", params["route"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            IFileInfoIEnumerableDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static previewlist(
        params: {
            /**  */
            uploadId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<IFileInfoIEnumerableDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/FileUpload/previewlist/{uploadId}";
            url = url.replace("{uploadId}", params["uploadId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            IFileInfoIEnumerableDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static previewlink(
        params: {
            /**  */
            uploadId: string;
            /**  */
            filename: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<StringDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/FileUpload/previewlink/{uploadId}/{filename}";
            url = url.replace("{uploadId}", params["uploadId"] + "");
            url = url.replace("{filename}", params["filename"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(StringDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static list1(
        options: IRequestOptions = {}
    ): Promise<IFileInfoIEnumerableDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/FileUpload/list";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            IFileInfoIEnumerableDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static upload(
        params: {
            /**  */
            file: any;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/FileUpload/upload";

            const configs: IRequestConfig = getConfigs(
                "post",
                "multipart/form-data",
                url,
                options
            );

            let data = null;
            data = new FormData();
            if (params["file"]) {
                if (
                    Object.prototype.toString.call(params["file"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["file"]) {
                        data.append("file", item as any);
                    }
                } else {
                    data.append("file", params["file"] as any);
                }
            }

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static delete(
        params: {
            /**  */
            filename: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/FileUpload/delete/{filename}";
            url = url.replace("{filename}", params["filename"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
}

export class GeneratedDocumentService {
    /**
     *
     */
    static getReadyToGenerate(
        options: IRequestOptions = {}
    ): Promise<GeneratedDocumentListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/GeneratedDocument/GetReadyToGenerate";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            GeneratedDocumentListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static getReadyToGeneratePaged(
        params: {
            /**  */
            page?: number;
            /**  */
            amount?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GeneratedDocumentPagedResultDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/GeneratedDocument/GetReadyToGeneratePaged";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { page: params["page"], amount: params["amount"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            GeneratedDocumentPagedResultDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static generated(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/GeneratedDocument/{id}/Generated";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static generatedDocument(
        options: IRequestOptions = {}
    ): Promise<GeneratedDocumentIEnumerableAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/GeneratedDocument";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            GeneratedDocumentIEnumerableAPIResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static generatedDocument1(
        params: {
            /** requestBody */
            body?: GeneratedDocument;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GeneratedDocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/GeneratedDocument";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(GeneratedDocumentAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static generatedDocument2(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GeneratedDocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/GeneratedDocument/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(GeneratedDocumentAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static generatedDocument3(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: GeneratedDocument;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GeneratedDocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/GeneratedDocument/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(GeneratedDocumentAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static generatedDocument4(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GeneratedDocumentAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/GeneratedDocument/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(GeneratedDocumentAPIResponse, response)
                    ),
                reject
            );
        });
    }
}

export class OrderService {
    /**
     *
     */
    static order(
        params: {
            /** requestBody */
            body?: OrderRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<OrderReceiptDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Order";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(OrderReceiptDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class PartyService {
    /**
     *
     */
    static parties(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Party/parties/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static party(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: PartyRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Party/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static party1(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: PartyRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Party/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static party2(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: PartyRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Party/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static leadAttorney(
        params: {
            /**  */
            submissionId: string;
            /**  */
            newLeadAttorney?: boolean;
            /** requestBody */
            body?: Party;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<PartyDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Party/leadAttorney/{submissionID}";
            url = url.replace("{submissionID}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { newLeadAttorney: params["newLeadAttorney"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(PartyDetailedResponse, response)),
                reject
            );
        });
    }
}

export class PendingServiceDocumentService {
    /**
     *
     */
    static notify(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: IgnoreService;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/PendingServiceDocument/notify/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static ignore(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: IgnoreService;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/PendingServiceDocument/ignore/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static list(
        options: IRequestOptions = {}
    ): Promise<PendingServiceDocumentListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/PendingServiceDocument/list";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            PendingServiceDocumentListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class QueueService {
    /**
     *
     */
    static import(
        params: {
            /** requestBody */
            body?: ImportRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/Import";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static queue(
        params: {
            /**  */
            filter: string;
            /**  */
            state: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<AttorneyQueueListAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/queue/{filter}/{state}";
            url = url.replace("{filter}", params["filter"] + "");
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(AttorneyQueueListAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static byAttorney(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            filter: string;
            /**  */
            state: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<QueuedSubmissionListAPIResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Queue/ByAttorney/{attorneyId}/{filter}/{state}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace("{filter}", params["filter"] + "");
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(QueuedSubmissionListAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static count(
        options: IRequestOptions = {}
    ): Promise<QueueCountDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/count";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(QueueCountDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static next(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            filter: string;
            /**  */
            state: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Queue/next/{attorneyId}/{filter}/{state}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace("{filter}", params["filter"] + "");
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submission(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/submission/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submit(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            filter?: string;
            /**  */
            state?: string;
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/submit";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                filter: params["filter"],
                state: params["state"],
            };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submitFromCache(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            filter?: string;
            /**  */
            state?: string;
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/submitFromCache";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                filter: params["filter"],
                state: params["state"],
            };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static serve(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            filter?: string;
            /**  */
            state?: string;
            /** requestBody */
            body?: ApprovedServiceRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/serve";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                filter: params["filter"],
                state: params["state"],
            };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static dfs(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            filter?: string;
            /**  */
            state?: string;
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/submit/dfs";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                filter: params["filter"],
                state: params["state"],
            };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filed(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/filed";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static served(
        params: {
            /** requestBody */
            body?: ServedRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/served";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static cancelAll(
        params: {
            /**  */
            attorneyId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/cancelAll/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static cancelAutoFile(
        params: {
            /**  */
            attorneyId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/cancelAutoFile/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static checkSimilar(
        params: {
            /** requestBody */
            body?: CheckSimilarRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/checkSimilar";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static cancel(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/cancel/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static cancelHold(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/cancelHold/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static hold(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/hold/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static hide(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/hide/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static fail(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/fail/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static errorsubmitting(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/errorsubmitting/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submission1(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/readd/submission/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorney(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/readd/attorney/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static sync(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/sync/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorney1(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/sync/attorney/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static aipopulate(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/aipopulate/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorney2(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            filter: string;
            /**  */
            state: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Queue/aipopulate/attorney/{attorneyId}/{filter}/{state}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace("{filter}", params["filter"] + "");
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorney3(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/autofile/attorney/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static fileId(
        params: {
            /**  */
            fileId: number;
            /**  */
            firmId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/fileId/{fileId}/{firmId}";
            url = url.replace("{fileId}", params["fileId"] + "");
            url = url.replace("{firmId}", params["firmId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static deleteEfmeSubmit(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/deleteEFMESubmit/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static test(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Queue/autofile/test/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static query(
        params: {
            /** requestBody */
            body?: HoldRetryRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/Queue/retry/query";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static queue1(
        params: {
            /**  */
            filter: string;
            /**  */
            state?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<QueuedSubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/Queue/{filter}";
            url = url.replace("{filter}", params["filter"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { state: params["state"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            QueuedSubmissionListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static queue2(
        params: {
            /**  */
            submissionId: string;
            /**  */
            state: string;
            /**  */
            pattern?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/Queue/{submissionId}/{state}";
            url = url.replace("{submissionId}", params["submissionId"] + "");
            url = url.replace("{state}", params["state"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { pattern: params["pattern"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
}

export class ReportingService {
    /**
     *
     */
    static last90Days(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Int32ArrayNameValue[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/last90days";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(Int32ArrayNameValue, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static portalIdentifier(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Int32NameValue[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/PortalIdentifier";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(Int32NameValue, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static monthly(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Int32ArrayNameValue[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/Monthly";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(Int32ArrayNameValue, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static today(
        params: {
            /**  */
            userId?: string;
            /**  */
            pageNumber?: number;
            /**  */
            itemsPerPage?: number;
            /**  */
            searchString?: string;
            /**  */
            orderBy?: string;
            /**  */
            orderDirection?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ReportSubmissionPagedResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/today";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                UserID: params["userId"],
                PageNumber: params["pageNumber"],
                ItemsPerPage: params["itemsPerPage"],
                SearchString: params["searchString"],
                OrderBy: params["orderBy"],
                OrderDirection: params["orderDirection"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(ReportSubmissionPagedResult, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static existing(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/today/Existing";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static new(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/today/New";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static dfs(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/today/DFS";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static totalFilings(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/TotalFilings/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static reporting(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: ReportingRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionPagedResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/reporting";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionPagedResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static search(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: SubmissionReportingRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionSearchResultsListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/search";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            SubmissionSearchResultsListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static efilereport(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: EFileReportRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFileReportRowListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/efilereport";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFileReportRowListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static recent(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFileRecentReportRowListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/recent";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFileRecentReportRowListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static efilereport1(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: EFileReportRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFileReportRowListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/v5/efilereport";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFileReportRowListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static status(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            perPage?: number;
            /**  */
            page?: number;
            /** requestBody */
            body?: FilingStatusReportFilter;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionFilingPagedResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Reporting/filing/status";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                perPage: params["perPage"],
                page: params["page"],
            };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionFilingPagedResult, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static email(
        params: {
            /** requestBody */
            body?: BillingReportRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BillingReportReceiptDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/billing/email";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            BillingReportReceiptDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static last90Days1(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Int32ArrayNameValue[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/last90days";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(Int32ArrayNameValue, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static portalIdentifier1(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Int32NameValue[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/PortalIdentifier";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(Int32NameValue, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static monthly1(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Int32ArrayNameValue[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/Monthly";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any[]) =>
                    resolve(plainToClass(Int32ArrayNameValue, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static today1(
        params: {
            /**  */
            userId?: string;
            /**  */
            pageNumber?: number;
            /**  */
            itemsPerPage?: number;
            /**  */
            searchString?: string;
            /**  */
            orderBy?: string;
            /**  */
            orderDirection?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ReportSubmissionPagedResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/today";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                UserID: params["userId"],
                PageNumber: params["pageNumber"],
                ItemsPerPage: params["itemsPerPage"],
                SearchString: params["searchString"],
                OrderBy: params["orderBy"],
                OrderDirection: params["orderDirection"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(ReportSubmissionPagedResult, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static existing1(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/today/Existing";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static new1(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/today/New";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static dfs1(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/today/DFS";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static totalFilings1(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ProgressResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/TotalFilings/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(ProgressResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static reporting1(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: ReportingRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionPagedResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/reporting";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionPagedResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static search1(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: SubmissionReportingRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionSearchResultsListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/search";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            SubmissionSearchResultsListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static efilereport2(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: EFileReportRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFileReportRowListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/efilereport";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFileReportRowListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static efilereport3(
        params: {
            /**  */
            userId?: string;
            /**  */
            fromDate?: string;
            /**  */
            toDate?: string;
            /**  */
            searchBy?: number;
            /**  */
            contains?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFileReportRowListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/user/efilereport";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                userId: params["userId"],
                fromDate: params["fromDate"],
                toDate: params["toDate"],
                searchBy: params["searchBy"],
                contains: params["contains"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFileReportRowListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static recent1(
        params: {
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFileRecentReportRowListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/recent";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFileRecentReportRowListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static efilereport4(
        params: {
            /**  */
            attorneyId?: string;
            /** requestBody */
            body?: EFileReportRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFileReportRowListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/v5/efilereport";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = { attorneyId: params["attorneyId"] };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFileReportRowListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static status1(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            perPage?: number;
            /**  */
            page?: number;
            /** requestBody */
            body?: FilingStatusReportFilter;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionFilingPagedResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Reporting/filing/status";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                perPage: params["perPage"],
                page: params["page"],
            };
            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionFilingPagedResult, response)
                    ),
                reject
            );
        });
    }
}

export class ServiceRequestService {
    /**
     *
     */
    static create(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ServiceRequestDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/auth/ServiceRequest/create/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(ServiceRequestDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static getByUcn(
        params: {
            /**  */
            ucn: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ServiceRequestDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/ServiceRequest/getByUCN/{UCN}";
            url = url.replace("{UCN}", params["ucn"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(ServiceRequestDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static updateUcn(
        params: {
            /**  */
            submissionId: string;
            /**  */
            ucn: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ServiceRequestDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/auth/ServiceRequest/updateUCN/{submissionId}/{UCN}";
            url = url.replace("{submissionId}", params["submissionId"] + "");
            url = url.replace("{UCN}", params["ucn"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(ServiceRequestDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static getBySubmissionId(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ServiceRequestDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/auth/ServiceRequest/getBySubmissionID/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(ServiceRequestDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static getActive(
        options: IRequestOptions = {}
    ): Promise<ServiceRequestListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/ServiceRequest/getActive";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            ServiceRequestListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class SubmissionService {
    /**
     *
     */
    static fix(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/fix/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static fileId(
        params: {
            /**  */
            fileId: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/fileId/{fileId}";
            url = url.replace("{fileId}", params["fileId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filed(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            startDate?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionIEnumerableDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/filed/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { startDate: params["startDate"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            SubmissionIEnumerableDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static page(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            page: number;
            /**  */
            startDate?: string;
            /**  */
            recordsPerPage?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionPagedResultDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/filed/{attorneyId}/page/{page}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace("{page}", params["page"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                startDate: params["startDate"],
                recordsPerPage: params["recordsPerPage"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            SubmissionPagedResultDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static filed1(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/filed";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static served(
        params: {
            /** requestBody */
            body?: ServedRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/served";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static errorsubmitting(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: ActionRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/errorsubmitting/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static fees(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: UpdateFeesRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<FeeListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/fees/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(FeeListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static errorSendingEmail(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/ErrorSendingEmail/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static permRemoveFromQueue(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/PermRemoveFromQueue/{submissionID}";
            url = url.replace("{submissionID}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static autofile(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            pattern: string;
            /**  */
            limit: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Submission/autofile/{attorneyId}/{pattern}/{limit}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace("{pattern}", params["pattern"] + "");
            url = url.replace("{limit}", params["limit"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static resendEmails(
        options: IRequestOptions = {}
    ): Promise<SubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/ResendEmails";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static removefromqueue(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/removefromqueue/{submissionID}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static hold(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/hold/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static accepted(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: AcceptedRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/accepted/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static rejected(
        params: {
            /**  */
            submissionId: string;
            /** requestBody */
            body?: RejectedRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/rejected/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static cancel(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/cancel/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static autofile1(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/autofile/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static queue(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/Queue/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionListAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static portalStatus(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<StringDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/PortalStatus/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(StringDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static filename(
        params: {
            /**  */
            filename?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/PendingApproval/filename";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { filename: params["filename"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionListAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorney(
        params: {
            /**  */
            id?: string;
            /**  */
            limit?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/PendingApproval/attorney";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { id: params["id"], limit: params["limit"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionListAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static paged(
        params: {
            /**  */
            id?: string;
            /**  */
            page?: number;
            /**  */
            limit?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionPagedResultAPIResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/PendingApproval/attorney/paged";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                id: params["id"],
                page: params["page"],
                limit: params["limit"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionPagedResultAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static failed(
        params: {
            /**  */
            date: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/failed/{date}";
            url = url.replace("{date}", params["date"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionListAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static pendingCaseNumber(
        params: {
            /** requestBody */
            body?: Submission[];
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/pending-case-number";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static parsed(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/parsed/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static updateDocumentCount(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Submission/update-document-count/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static doubleFile(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DoubleFileStatusDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/check/doubleFile/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(DoubleFileStatusDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static getServiceSuitData(
        params: {
            /**  */
            submissionId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ServiceSuitDataDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/Submission/getServiceSuitData/{submissionId}";
            url = url.replace("{submissionId}", params["submissionId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(ServiceSuitDataDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static originalNewSuit(
        params: {
            /**  */
            county?: string;
            /**  */
            caseNumber?: string;
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/original-new-suit";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                county: params["county"],
                caseNumber: params["caseNumber"],
                attorneyId: params["attorneyId"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static pendingCaseNumber1(
        params: {
            /**  */
            days: number;
            /**  */
            page?: number;
            /**  */
            amount?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionPagedResultDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/pending-case-number/{days}";
            url = url.replace("{days}", params["days"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { page: params["page"], amount: params["amount"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            SubmissionPagedResultDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static insert(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Int32DetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/v1/insert";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(Int32DetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submission(
        options: IRequestOptions = {}
    ): Promise<SubmissionIEnumerableAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionIEnumerableAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static submission1(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submission2(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submission3(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submission4(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Submission/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
}

export class SubmissionDetailService {
    /**
     *
     */
    static searchSubmissions(
        params: {
            /**  */
            search: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath + "/api/SubmissionDetail/SearchSubmissions/{search}";
            url = url.replace("{search}", params["search"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionUpdate(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SubmissionDetail/submissionUpdate";

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail(
        options: IRequestOptions = {}
    ): Promise<SubmissionIEnumerableAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SubmissionDetail";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionIEnumerableAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail1(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SubmissionDetail";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail2(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SubmissionDetail/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail3(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SubmissionDetail/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail4(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SubmissionDetail/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static attorney(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            matterNumber: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseDataListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/auth/SubmissionDetail/attorney/{attorneyId}/{matterNumber}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace("{matterNumber}", params["matterNumber"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CaseDataListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static matter(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            caseNumber: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<StringDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/auth/SubmissionDetail/matter/{attorneyId}/{caseNumber}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace("{caseNumber}", params["caseNumber"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(StringDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail5(
        options: IRequestOptions = {}
    ): Promise<SubmissionIEnumerableAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/SubmissionDetail";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionIEnumerableAPIResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail6(
        params: {
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/SubmissionDetail";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail7(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/SubmissionDetail/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail8(
        params: {
            /**  */
            id: string;
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/SubmissionDetail/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "put",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static submissionDetail9(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionAPIResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/auth/SubmissionDetail/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionAPIResponse, response)),
                reject
            );
        });
    }
}

export class SystemSettingsService {
    /**
     *
     */
    static systemSettings(
        options: IRequestOptions = {}
    ): Promise<EFMESystemSettingsDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SystemSettings";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFMESystemSettingsDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static refresh(
        options: IRequestOptions = {}
    ): Promise<EFMESystemSettingsDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SystemSettings/refresh";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFMESystemSettingsDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static update(
        params: {
            /** requestBody */
            body?: EFMESystemSettings;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<EFMESystemSettingsDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SystemSettings/update";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFMESystemSettingsDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static clear(
        options: IRequestOptions = {}
    ): Promise<EFMESystemSettingsDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/SystemSettings/clear";

            const configs: IRequestConfig = getConfigs(
                "delete",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            EFMESystemSettingsDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class ThirdPartyService {
    /**
     *
     */
    static existingpackage(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            attorneyUid: string;
            /**  */
            caseData: string;
            /**  */
            package: [];
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/ThirdParty/file/existingpackage";

            const configs: IRequestConfig = getConfigs(
                "post",
                "multipart/form-data",
                url,
                options
            );

            let data = null;
            data = new FormData();
            if (params["attorneyId"]) {
                if (
                    Object.prototype.toString.call(params["attorneyId"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["attorneyId"]) {
                        data.append("AttorneyID", item as any);
                    }
                } else {
                    data.append("AttorneyID", params["attorneyId"] as any);
                }
            }

            if (params["attorneyUid"]) {
                if (
                    Object.prototype.toString.call(params["attorneyUid"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["attorneyUid"]) {
                        data.append("AttorneyUID", item as any);
                    }
                } else {
                    data.append("AttorneyUID", params["attorneyUid"] as any);
                }
            }

            if (params["caseData"]) {
                if (
                    Object.prototype.toString.call(params["caseData"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["caseData"]) {
                        data.append("CaseData", item as any);
                    }
                } else {
                    data.append("CaseData", params["caseData"] as any);
                }
            }

            if (params["package"]) {
                if (
                    Object.prototype.toString.call(params["package"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["package"]) {
                        data.append("Package", item as any);
                    }
                } else {
                    data.append("Package", params["package"] as any);
                }
            }

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static newpackage(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            attorneyUid: string;
            /**  */
            caseData: string;
            /**  */
            package: [];
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/ThirdParty/file/newpackage";

            const configs: IRequestConfig = getConfigs(
                "post",
                "multipart/form-data",
                url,
                options
            );

            let data = null;
            data = new FormData();
            if (params["attorneyId"]) {
                if (
                    Object.prototype.toString.call(params["attorneyId"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["attorneyId"]) {
                        data.append("AttorneyID", item as any);
                    }
                } else {
                    data.append("AttorneyID", params["attorneyId"] as any);
                }
            }

            if (params["attorneyUid"]) {
                if (
                    Object.prototype.toString.call(params["attorneyUid"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["attorneyUid"]) {
                        data.append("AttorneyUID", item as any);
                    }
                } else {
                    data.append("AttorneyUID", params["attorneyUid"] as any);
                }
            }

            if (params["caseData"]) {
                if (
                    Object.prototype.toString.call(params["caseData"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["caseData"]) {
                        data.append("CaseData", item as any);
                    }
                } else {
                    data.append("CaseData", params["caseData"] as any);
                }
            }

            if (params["package"]) {
                if (
                    Object.prototype.toString.call(params["package"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["package"]) {
                        data.append("Package", item as any);
                    }
                } else {
                    data.append("Package", params["package"] as any);
                }
            }

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static orderpackage(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            attorneyUid: string;
            /**  */
            caseData: string;
            /**  */
            package: [];
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/ThirdParty/file/orderpackage";

            const configs: IRequestConfig = getConfigs(
                "post",
                "multipart/form-data",
                url,
                options
            );

            let data = null;
            data = new FormData();
            if (params["attorneyId"]) {
                if (
                    Object.prototype.toString.call(params["attorneyId"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["attorneyId"]) {
                        data.append("AttorneyID", item as any);
                    }
                } else {
                    data.append("AttorneyID", params["attorneyId"] as any);
                }
            }

            if (params["attorneyUid"]) {
                if (
                    Object.prototype.toString.call(params["attorneyUid"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["attorneyUid"]) {
                        data.append("AttorneyUID", item as any);
                    }
                } else {
                    data.append("AttorneyUID", params["attorneyUid"] as any);
                }
            }

            if (params["caseData"]) {
                if (
                    Object.prototype.toString.call(params["caseData"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["caseData"]) {
                        data.append("CaseData", item as any);
                    }
                } else {
                    data.append("CaseData", params["caseData"] as any);
                }
            }

            if (params["package"]) {
                if (
                    Object.prototype.toString.call(params["package"]) ===
                    "[object Array]"
                ) {
                    for (const item of params["package"]) {
                        data.append("Package", item as any);
                    }
                } else {
                    data.append("Package", params["package"] as any);
                }
            }

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static getstatus(
        params: {
            /**  */
            uploadId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<UploadStatusDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/ThirdParty/getstatus/{uploadId}";
            url = url.replace("{uploadId}", params["uploadId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(UploadStatusDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static matter(
        params: {
            /** requestBody */
            body?: CancelByMatter;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/ThirdParty/cancel/matter";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static additionalCaseInformation(
        params: {
            /**  */
            state: string;
            /**  */
            ucn: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocketDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/ThirdParty/additionalCaseInformation/{state}/{ucn}";
            url = url.replace("{state}", params["state"] + "");
            url = url.replace("{ucn}", params["ucn"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocketDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static additionalCaseInformation1(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            matter?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<DocketDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/ThirdParty/additionalCaseInformation/{attorneyId}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { matter: params["matter"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(DocketDetailedResponse, response)),
                reject
            );
        });
    }
}

export class TylerSubmissionService {
    /**
     *
     */
    static tylerSubmission(
        params: {
            /**  */
            isExistingCase: boolean;
            /** requestBody */
            body?: Submission;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/TylerSubmission/{isExistingCase}";
            url = url.replace(
                "{isExistingCase}",
                params["isExistingCase"] + ""
            );

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(SubmissionDetailedResponse, response)),
                reject
            );
        });
    }
}

export class UploadService {
    /**
     *
     */
    static presigned(
        params: {
            /**  */
            filename: string;
            /** requestBody */
            body?: PresignedUploadRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<StringDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/key/Upload/presigned/{filename}";
            url = url.replace("{filename}", params["filename"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(StringDetailedResponse, response)),
                reject
            );
        });
    }
}

export class UploadsService {
    /**
     *
     */
    static today(
        params: {
            /**  */
            userId?: string;
            /**  */
            pageNumber?: number;
            /**  */
            itemsPerPage?: number;
            /**  */
            searchString?: string;
            /**  */
            orderBy?: string;
            /**  */
            orderDirection?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<UploadPagedResult> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Uploads/today";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                UserID: params["userId"],
                PageNumber: params["pageNumber"],
                ItemsPerPage: params["itemsPerPage"],
                SearchString: params["searchString"],
                OrderBy: params["orderBy"],
                OrderDirection: params["orderDirection"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(UploadPagedResult, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static cancel(
        params: {
            /**  */
            uploadId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SubmissionListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Uploads/cancel/{uploadId}";
            url = url.replace("{uploadId}", params["uploadId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(SubmissionListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static sethash(
        params: {
            /**  */
            uploadId: string;
            /**  */
            filehash?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Uploads/sethash/{uploadId}";
            url = url.replace("{uploadId}", params["uploadId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { filehash: params["filehash"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static errorUploading(
        params: {
            /**  */
            uploadId: string;
            /** requestBody */
            body?: ErrorUploadingRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Uploads/errorUploading/{uploadId}";
            url = url.replace("{uploadId}", params["uploadId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static largeUpload(
        params: {
            /**  */
            uploadId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Uploads/large-upload/{uploadId}";
            url = url.replace("{uploadId}", params["uploadId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static uploadedby(
        params: {
            /**  */
            uploadedById: string;
            /**  */
            startDate?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<UploadIEnumerableDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Uploads/uploadedby/{uploadedById}";
            url = url.replace("{uploadedById}", params["uploadedById"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { startDate: params["startDate"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            UploadIEnumerableDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
}

export class V1Service {
    /**
     *
     */
    static queue(
        params: {
            /**  */
            uid: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<V1FileListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/V1/Queue/{uid}";
            url = url.replace("{uid}", params["uid"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(V1FileListDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static file(
        params: {
            /**  */
            fileId: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<V1FileDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/V1/File/{fileId}";
            url = url.replace("{fileId}", params["fileId"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(V1FileDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static insert(
        params: {
            /** requestBody */
            body?: V1InsertRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<V1FileDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/V1/Queue/Insert";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(V1FileDetailedResponse, response)),
                reject
            );
        });
    }
}

export class AcceptedRequest {
    /**  */
    @Expose()
    @Type(() => Date)
    "acceptedDateTime"?: Date;

    /**  */
    "ucn"?: string;

    /**  */
    "courtCaseNumber"?: string;

    constructor(data: undefined | any = {}) {
        this["acceptedDateTime"] = data["acceptedDateTime"];
        this["ucn"] = data["ucn"];
        this["courtCaseNumber"] = data["courtCaseNumber"];
    }

    public static validationModel = {};
}

export class ActionRequest {
    /**  */
    @Expose()
    "defaultMessage"?: number;

    /**  */
    "message"?: string;

    /**  */
    "filter"?: string;

    /**  */
    "state"?: string;

    constructor(data: undefined | any = {}) {
        this["defaultMessage"] = data["defaultMessage"];
        this["message"] = data["message"];
        this["filter"] = data["filter"];
        this["state"] = data["state"];
    }

    public static validationModel = {};
}

export class Address {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "fullAddress"?: string;

    /**  */
    "streetAddress"?: string;

    /**  */
    "unit"?: string;

    /**  */
    "city"?: string;

    /**  */
    "state"?: string;

    /**  */
    "zip"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    @Expose()
    "latitude"?: number;

    /**  */
    @Expose()
    "longitude"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["fullAddress"] = data["fullAddress"];
        this["streetAddress"] = data["streetAddress"];
        this["unit"] = data["unit"];
        this["city"] = data["city"];
        this["state"] = data["state"];
        this["zip"] = data["zip"];
        this["active"] = data["active"];
        this["latitude"] = data["latitude"];
        this["longitude"] = data["longitude"];
    }

    public static validationModel = {};
}

export class ApprovedServiceRequest {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "originalNewCaseSubmissionID"?: string;

    /**  */
    "serviceSubmission"?: Submission;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["originalNewCaseSubmissionID"] =
            data["originalNewCaseSubmissionID"];
        this["serviceSubmission"] = data["serviceSubmission"];
    }

    public static validationModel = {};
}

export class Attorney {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    @Expose()
    "firmID"?: string;

    /**  */
    "ePortalID"?: string;

    /**  */
    @Expose()
    "v1_ID"?: number;

    /**  */
    "firstName"?: string;

    /**  */
    "middleName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "fullName"?: string;

    /**  */
    "emailAddress"?: string;

    /**  */
    "serviceEmails"?: string;

    /**  */
    "assistantEmails"?: string;

    /**  */
    "extraEmails"?: string;

    /**  */
    "blacklistEmails"?: string;

    /**  */
    "bccEmails"?: string;

    /**  */
    "replyEmail"?: string;

    /**  */
    "failedEmail"?: string;

    /**  */
    "phoneNumber"?: string;

    /**  */
    "state"?: string;

    /**  */
    "barNumber"?: string;

    /**  */
    "efmeDirectory"?: string;

    /**  */
    "processPendingQueue"?: boolean;

    /**  */
    "monitorPendingQueue"?: boolean;

    /**  */
    "pendingQueueEmail"?: string;

    /**  */
    "useDocumentEmails"?: boolean;

    /**  */
    "usePortalEmails"?: boolean;

    /**  */
    "serveThroughPortal"?: boolean;

    /**  */
    "noService"?: boolean;

    /**  */
    "noPortalService"?: boolean;

    /**  */
    "useClientControlID"?: boolean;

    /**  */
    "controlNumberInFilename"?: boolean;

    /**  */
    "holdIncoming"?: boolean;

    /**  */
    "allowOCR"?: boolean;

    /**  */
    "autoFileExisting"?: boolean;

    /**  */
    "autoFileNew"?: boolean;

    /**  */
    "cvv"?: string;

    /**  */
    @Expose()
    "newCasePrice"?: number;

    /**  */
    @Expose()
    "existingCasePrice"?: number;

    /**  */
    "signature"?: string;

    /**  */
    "cleanFilename"?: boolean;

    /**  */
    "stampPDF"?: boolean;

    /**  */
    "active"?: boolean;

    /**  */
    "preProcessIncomingFiles"?: boolean;

    /**  */
    "useBarcode"?: boolean;

    /**  */
    "serveAll"?: boolean;

    /**  */
    "efmeReciept"?: boolean;

    /**  */
    "attorneyType"?: AttorneyType;

    /**  */
    "firm"?: Firm;

    /**  */
    "address"?: Address;

    /**  */
    "portalConfigurations"?: PortalConfiguration[];

    /**  */
    "directory"?: string;

    /**  */
    @Expose()
    "addressID"?: string;

    /**  */
    @Expose()
    "attorneyTypeKey"?: number;

    /**  */
    "display"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["attorneyID"] = data["attorneyID"];
        this["firmID"] = data["firmID"];
        this["ePortalID"] = data["ePortalID"];
        this["v1_ID"] = data["v1_ID"];
        this["firstName"] = data["firstName"];
        this["middleName"] = data["middleName"];
        this["lastName"] = data["lastName"];
        this["fullName"] = data["fullName"];
        this["emailAddress"] = data["emailAddress"];
        this["serviceEmails"] = data["serviceEmails"];
        this["assistantEmails"] = data["assistantEmails"];
        this["extraEmails"] = data["extraEmails"];
        this["blacklistEmails"] = data["blacklistEmails"];
        this["bccEmails"] = data["bccEmails"];
        this["replyEmail"] = data["replyEmail"];
        this["failedEmail"] = data["failedEmail"];
        this["phoneNumber"] = data["phoneNumber"];
        this["state"] = data["state"];
        this["barNumber"] = data["barNumber"];
        this["efmeDirectory"] = data["efmeDirectory"];
        this["processPendingQueue"] = data["processPendingQueue"];
        this["monitorPendingQueue"] = data["monitorPendingQueue"];
        this["pendingQueueEmail"] = data["pendingQueueEmail"];
        this["useDocumentEmails"] = data["useDocumentEmails"];
        this["usePortalEmails"] = data["usePortalEmails"];
        this["serveThroughPortal"] = data["serveThroughPortal"];
        this["noService"] = data["noService"];
        this["noPortalService"] = data["noPortalService"];
        this["useClientControlID"] = data["useClientControlID"];
        this["controlNumberInFilename"] = data["controlNumberInFilename"];
        this["holdIncoming"] = data["holdIncoming"];
        this["allowOCR"] = data["allowOCR"];
        this["autoFileExisting"] = data["autoFileExisting"];
        this["autoFileNew"] = data["autoFileNew"];
        this["cvv"] = data["cvv"];
        this["newCasePrice"] = data["newCasePrice"];
        this["existingCasePrice"] = data["existingCasePrice"];
        this["signature"] = data["signature"];
        this["cleanFilename"] = data["cleanFilename"];
        this["stampPDF"] = data["stampPDF"];
        this["active"] = data["active"];
        this["preProcessIncomingFiles"] = data["preProcessIncomingFiles"];
        this["useBarcode"] = data["useBarcode"];
        this["serveAll"] = data["serveAll"];
        this["efmeReciept"] = data["efmeReciept"];
        this["attorneyType"] = data["attorneyType"];
        this["firm"] = data["firm"];
        this["address"] = data["address"];
        this["portalConfigurations"] = data["portalConfigurations"];
        this["directory"] = data["directory"];
        this["addressID"] = data["addressID"];
        this["attorneyTypeKey"] = data["attorneyTypeKey"];
        this["display"] = data["display"];
    }

    public static validationModel = {};
}

export class AttorneyQueue {
    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "name"?: string;

    /**  */
    "emergency"?: boolean;

    /**  */
    @Expose()
    "submissionCount"?: number;

    /**  */
    @Expose()
    @Type(() => Date)
    "oldestFileDate"?: Date;

    constructor(data: undefined | any = {}) {
        this["attorneyID"] = data["attorneyID"];
        this["name"] = data["name"];
        this["emergency"] = data["emergency"];
        this["submissionCount"] = data["submissionCount"];
        this["oldestFileDate"] = data["oldestFileDate"];
    }

    public static validationModel = {};
}

export class AttorneyQueueListAPIResponse {
    /**  */
    "data"?: AttorneyQueue[];

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class AttorneyType {
    /**  */
    "description"?: string;

    /**  */
    @Expose()
    "key"?: number;

    constructor(data: undefined | any = {}) {
        this["description"] = data["description"];
        this["key"] = data["key"];
    }

    public static validationModel = {};
}

export class BatchFile {
    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "size"?: number;

    constructor(data: undefined | any = {}) {
        this["filename"] = data["filename"];
        this["size"] = data["size"];
    }

    public static validationModel = {};
}

export class BatchUploadRequests {
    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "dataRows"?: number;

    /**  */
    @Expose()
    "totalDocuments"?: number;

    /**  */
    "files"?: BatchFile[];

    /**  */
    "uploadedBy"?: string;

    constructor(data: undefined | any = {}) {
        this["filename"] = data["filename"];
        this["dataRows"] = data["dataRows"];
        this["totalDocuments"] = data["totalDocuments"];
        this["files"] = data["files"];
        this["uploadedBy"] = data["uploadedBy"];
    }

    public static validationModel = {};
}

export class BatchUploadResponse {
    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "dataRows"?: number;

    /**  */
    @Expose()
    "totalDocuments"?: number;

    /**  */
    "uploadedBy"?: string;

    /**  */
    @Expose()
    "id"?: string;

    constructor(data: undefined | any = {}) {
        this["filename"] = data["filename"];
        this["dataRows"] = data["dataRows"];
        this["totalDocuments"] = data["totalDocuments"];
        this["uploadedBy"] = data["uploadedBy"];
        this["id"] = data["id"];
    }

    public static validationModel = {};
}

export class BatchUploadResponseDetailedResponse {
    /**  */
    "data"?: BatchUploadResponse;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class BatchUploadResponseListDetailedResponse {
    /**  */
    "data"?: BatchUploadResponse[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class BeginUpload {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "filenames"?: string[];

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["filenames"] = data["filenames"];
    }

    public static validationModel = {};
}

export class BeginUploadDetailedResponse {
    /**  */
    "data"?: BeginUpload;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class BillingReportReceipt {
    /**  */
    @Expose()
    "attorneyId"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "startDate"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "endDate"?: Date;

    /**  */
    @Expose()
    "rowCount"?: number;

    /**  */
    @Expose()
    "courtFees"?: number;

    /**  */
    @Expose()
    "efmFees"?: number;

    /**  */
    @Expose()
    "total"?: number;

    /**  */
    "filename"?: string;

    /**  */
    "recipients"?: string[];

    constructor(data: undefined | any = {}) {
        this["attorneyId"] = data["attorneyId"];
        this["startDate"] = data["startDate"];
        this["endDate"] = data["endDate"];
        this["rowCount"] = data["rowCount"];
        this["courtFees"] = data["courtFees"];
        this["efmFees"] = data["efmFees"];
        this["total"] = data["total"];
        this["filename"] = data["filename"];
        this["recipients"] = data["recipients"];
    }

    public static validationModel = {};
}

export class BillingReportReceiptDetailedResponse {
    /**  */
    "data"?: BillingReportReceipt;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class BillingReportRequest {
    /**  */
    @Expose()
    "attorneyId"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "startDate"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "endDate"?: Date;

    /**  */
    "recipients"?: string[];

    /**  */
    "subject"?: string;

    constructor(data: undefined | any = {}) {
        this["attorneyId"] = data["attorneyId"];
        this["startDate"] = data["startDate"];
        this["endDate"] = data["endDate"];
        this["recipients"] = data["recipients"];
        this["subject"] = data["subject"];
    }

    public static validationModel = {};
}

export class BooleanAPIResponse {
    /**  */
    "data"?: boolean;

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class BooleanDetailedResponse {
    /**  */
    "data"?: boolean;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CancelByMatter {
    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "matterNumber"?: string;

    constructor(data: undefined | any = {}) {
        this["attorneyID"] = data["attorneyID"];
        this["matterNumber"] = data["matterNumber"];
    }

    public static validationModel = {};
}

export class CaseData {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    "county"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "division"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    /**  */
    "efmeCaseType"?: string;

    /**  */
    "caseType"?: string;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    /**  */
    @Expose()
    "caseTypeRuleID"?: string;

    /**  */
    "caseSubType"?: string;

    /**  */
    @Expose()
    "caseSubTypeID"?: string;

    /**  */
    "courtCaseNumber"?: string;

    /**  */
    "clientCaseNumber"?: string;

    /**  */
    "caseTitle"?: string;

    /**  */
    @Expose()
    "year"?: number;

    /**  */
    "sequenceNumber"?: string;

    /**  */
    "clientMatterNumber"?: string;

    /**  */
    "isClassAction"?: boolean;

    /**  */
    "hasRelatedCases"?: boolean;

    /**  */
    "demandForJuryTrial"?: boolean;

    /**  */
    @Expose()
    "totalDefendants"?: number;

    /**  */
    @Expose()
    "causeOfActionCount"?: number;

    /**  */
    "isMonetary"?: boolean;

    /**  */
    "isNonMonetary"?: boolean;

    /**  */
    "isInjunctiveRelief"?: boolean;

    /**  */
    "isPunitive"?: boolean;

    /**  */
    "isComplexBusiness"?: boolean;

    /**  */
    @Expose()
    "subpoenaCount"?: number;

    /**  */
    @Expose()
    "smallClaimsAmount"?: number;

    /**  */
    "relatedCaseNumber"?: string;

    /**  */
    "claimAmount"?: string;

    /**  */
    "beginDateOfService"?: string;

    /**  */
    "endDateOfService"?: string;

    /**  */
    "dateOfAccident"?: string;

    /**  */
    "paymentToken"?: string;

    /**  */
    @Expose()
    "summonsCount"?: number;

    /**  */
    "cvv"?: string;

    /**  */
    "serviceType"?: string;

    /**  */
    "judicialOfficerID"?: string;

    /**  */
    "leadAttorney"?: Party;

    /**  */
    "leadAttorneyBarNumber"?: string;

    /**  */
    @Expose()
    "damagesCodeID"?: string;

    /**  */
    @Expose()
    "divisionAddressID"?: string;

    /**  */
    "divisionAddress"?: Address;

    /**  */
    "policyNumber"?: string;

    /**  */
    "claimNumber"?: string;

    /**  */
    "filingPartyResponsible"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["ucn"] = data["ucn"];
        this["county"] = data["county"];
        this["countyID"] = data["countyID"];
        this["division"] = data["division"];
        this["divisionID"] = data["divisionID"];
        this["efmeCaseType"] = data["efmeCaseType"];
        this["caseType"] = data["caseType"];
        this["caseTypeID"] = data["caseTypeID"];
        this["caseTypeRuleID"] = data["caseTypeRuleID"];
        this["caseSubType"] = data["caseSubType"];
        this["caseSubTypeID"] = data["caseSubTypeID"];
        this["courtCaseNumber"] = data["courtCaseNumber"];
        this["clientCaseNumber"] = data["clientCaseNumber"];
        this["caseTitle"] = data["caseTitle"];
        this["year"] = data["year"];
        this["sequenceNumber"] = data["sequenceNumber"];
        this["clientMatterNumber"] = data["clientMatterNumber"];
        this["isClassAction"] = data["isClassAction"];
        this["hasRelatedCases"] = data["hasRelatedCases"];
        this["demandForJuryTrial"] = data["demandForJuryTrial"];
        this["totalDefendants"] = data["totalDefendants"];
        this["causeOfActionCount"] = data["causeOfActionCount"];
        this["isMonetary"] = data["isMonetary"];
        this["isNonMonetary"] = data["isNonMonetary"];
        this["isInjunctiveRelief"] = data["isInjunctiveRelief"];
        this["isPunitive"] = data["isPunitive"];
        this["isComplexBusiness"] = data["isComplexBusiness"];
        this["subpoenaCount"] = data["subpoenaCount"];
        this["smallClaimsAmount"] = data["smallClaimsAmount"];
        this["relatedCaseNumber"] = data["relatedCaseNumber"];
        this["claimAmount"] = data["claimAmount"];
        this["beginDateOfService"] = data["beginDateOfService"];
        this["endDateOfService"] = data["endDateOfService"];
        this["dateOfAccident"] = data["dateOfAccident"];
        this["paymentToken"] = data["paymentToken"];
        this["summonsCount"] = data["summonsCount"];
        this["cvv"] = data["cvv"];
        this["serviceType"] = data["serviceType"];
        this["judicialOfficerID"] = data["judicialOfficerID"];
        this["leadAttorney"] = data["leadAttorney"];
        this["leadAttorneyBarNumber"] = data["leadAttorneyBarNumber"];
        this["damagesCodeID"] = data["damagesCodeID"];
        this["divisionAddressID"] = data["divisionAddressID"];
        this["divisionAddress"] = data["divisionAddress"];
        this["policyNumber"] = data["policyNumber"];
        this["claimNumber"] = data["claimNumber"];
        this["filingPartyResponsible"] = data["filingPartyResponsible"];
    }

    public static validationModel = {};
}

export class CaseDataDetailedResponse {
    /**  */
    "data"?: CaseData;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CaseDataListDetailedResponse {
    /**  */
    "data"?: CaseData[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CaseDataRequest {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "county"?: string;

    /**  */
    "division"?: string;

    /**  */
    "caseType"?: string;

    /**  */
    "caseSubType"?: string;

    /**  */
    "courtCaseNumber"?: string;

    /**  */
    "clientCaseNumbaer"?: string;

    /**  */
    "caseTitle"?: string;

    /**  */
    "cvv"?: string;

    /**  */
    "claimAmount"?: string;

    /**  */
    "efmeCaseType"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["county"] = data["county"];
        this["division"] = data["division"];
        this["caseType"] = data["caseType"];
        this["caseSubType"] = data["caseSubType"];
        this["courtCaseNumber"] = data["courtCaseNumber"];
        this["clientCaseNumbaer"] = data["clientCaseNumbaer"];
        this["caseTitle"] = data["caseTitle"];
        this["cvv"] = data["cvv"];
        this["claimAmount"] = data["claimAmount"];
        this["efmeCaseType"] = data["efmeCaseType"];
    }

    public static validationModel = {};
}

export class CheckSimilarRequest {
    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "countyID"?: string;

    /**  */
    "divisionID"?: string;

    /**  */
    "caseTypeID"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "filedRangeStart"?: Date;

    constructor(data: undefined | any = {}) {
        this["attorneyID"] = data["attorneyID"];
        this["countyID"] = data["countyID"];
        this["divisionID"] = data["divisionID"];
        this["caseTypeID"] = data["caseTypeID"];
        this["filedRangeStart"] = data["filedRangeStart"];
    }

    public static validationModel = {};
}

export class Coversheet {
    /**  */
    "coversheetCourtType"?: string;

    /**  */
    "coversheetCaseType"?: string;

    /**  */
    "coversheetCaseSubType"?: string;

    /**  */
    "monetary"?: boolean;

    /**  */
    "nonMonetary"?: boolean;

    /**  */
    "punitive"?: boolean;

    /**  */
    "relief"?: boolean;

    /**  */
    "hasRelatedCases"?: boolean;

    /**  */
    "classAction"?: boolean;

    /**  */
    "juryTrial"?: boolean;

    /**  */
    "complexBusinessCourt"?: boolean;

    /**  */
    @Expose()
    "causesOfAction"?: number;

    /**  */
    @Expose()
    "numberOfDefendants"?: number;

    /**  */
    @Expose()
    "numberOfSubpoenas"?: number;

    /**  */
    @Expose()
    "claimAmount"?: number;

    /**  */
    "relatedCases"?: string;

    /**  */
    "hasDataFile"?: boolean;

    /**  */
    "dataFileName"?: string;

    constructor(data: undefined | any = {}) {
        this["coversheetCourtType"] = data["coversheetCourtType"];
        this["coversheetCaseType"] = data["coversheetCaseType"];
        this["coversheetCaseSubType"] = data["coversheetCaseSubType"];
        this["monetary"] = data["monetary"];
        this["nonMonetary"] = data["nonMonetary"];
        this["punitive"] = data["punitive"];
        this["relief"] = data["relief"];
        this["hasRelatedCases"] = data["hasRelatedCases"];
        this["classAction"] = data["classAction"];
        this["juryTrial"] = data["juryTrial"];
        this["complexBusinessCourt"] = data["complexBusinessCourt"];
        this["causesOfAction"] = data["causesOfAction"];
        this["numberOfDefendants"] = data["numberOfDefendants"];
        this["numberOfSubpoenas"] = data["numberOfSubpoenas"];
        this["claimAmount"] = data["claimAmount"];
        this["relatedCases"] = data["relatedCases"];
        this["hasDataFile"] = data["hasDataFile"];
        this["dataFileName"] = data["dataFileName"];
    }

    public static validationModel = {};
}

export class CoversheetSave {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "state"?: string;

    /**  */
    "name"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "coversheet"?: Coversheet;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["state"] = data["state"];
        this["name"] = data["name"];
        this["attorneyID"] = data["attorneyID"];
        this["coversheet"] = data["coversheet"];
    }

    public static validationModel = {};
}

export class CoversheetSaveDetailedResponse {
    /**  */
    "data"?: CoversheetSave;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CoversheetSaveListDetailedResponse {
    /**  */
    "data"?: CoversheetSave[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class DFS {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "uploadTypeKey"?: number;

    /**  */
    @Expose()
    "userID"?: string;

    /**  */
    "submittedBy"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "exhibits"?: Exhibits;

    /**  */
    "fileAsIndividuals"?: boolean;

    /**  */
    "ucn"?: string;

    /**  */
    "filenames"?: string[];

    /**  */
    "emergency"?: boolean;

    /**  */
    "matterNumber"?: string;

    /**  */
    @Expose()
    "serveWithSubmissionID"?: string;

    /**  */
    "filingParty"?: string;

    /**  */
    "flcEmail"?: string;

    /**  */
    @Expose()
    "eServiceOption"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["uploadTypeKey"] = data["uploadTypeKey"];
        this["userID"] = data["userID"];
        this["submittedBy"] = data["submittedBy"];
        this["attorneyID"] = data["attorneyID"];
        this["attorneyName"] = data["attorneyName"];
        this["filename"] = data["filename"];
        this["exhibits"] = data["exhibits"];
        this["fileAsIndividuals"] = data["fileAsIndividuals"];
        this["ucn"] = data["ucn"];
        this["filenames"] = data["filenames"];
        this["emergency"] = data["emergency"];
        this["matterNumber"] = data["matterNumber"];
        this["serveWithSubmissionID"] = data["serveWithSubmissionID"];
        this["filingParty"] = data["filingParty"];
        this["flcEmail"] = data["flcEmail"];
        this["eServiceOption"] = data["eServiceOption"];
    }

    public static validationModel = {};
}

export class DataTracReconcileItem {
    /**  */
    @Expose()
    "submissionId"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "referenceNumber"?: string;

    /**  */
    "clientMatterNumber"?: string;

    /**  */
    "efmeOutcome"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "outcomeDateTime"?: Date;

    /**  */
    "expectedDataTracStatus"?: string;

    /**  */
    "dataTracStatus"?: string;

    /**  */
    "dataTracOrderUuid"?: string;

    /**  */
    "inSync"?: boolean;

    /**  */
    "nativeOrderMissing"?: boolean;

    /**  */
    "nativeOrderRefreshed"?: boolean;

    /**  */
    "action"?: DataTracReconcileAction;

    /**  */
    "message"?: string;

    /**  */
    "overdue"?: boolean;

    /**  */
    "alerted"?: boolean;

    constructor(data: undefined | any = {}) {
        this["submissionId"] = data["submissionId"];
        this["filename"] = data["filename"];
        this["referenceNumber"] = data["referenceNumber"];
        this["clientMatterNumber"] = data["clientMatterNumber"];
        this["efmeOutcome"] = data["efmeOutcome"];
        this["outcomeDateTime"] = data["outcomeDateTime"];
        this["expectedDataTracStatus"] = data["expectedDataTracStatus"];
        this["dataTracStatus"] = data["dataTracStatus"];
        this["dataTracOrderUuid"] = data["dataTracOrderUuid"];
        this["inSync"] = data["inSync"];
        this["nativeOrderMissing"] = data["nativeOrderMissing"];
        this["nativeOrderRefreshed"] = data["nativeOrderRefreshed"];
        this["action"] = data["action"];
        this["message"] = data["message"];
        this["overdue"] = data["overdue"];
        this["alerted"] = data["alerted"];
    }

    public static validationModel = {};
}

export class DataTracReconcileRequest {
    /**  */
    @Expose()
    "attorneyId"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "startDate"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "endDate"?: Date;

    /**  */
    "dryRun"?: boolean;

    constructor(data: undefined | any = {}) {
        this["attorneyId"] = data["attorneyId"];
        this["startDate"] = data["startDate"];
        this["endDate"] = data["endDate"];
        this["dryRun"] = data["dryRun"];
    }

    public static validationModel = {};
}

export class DataTracReconcileResult {
    /**  */
    "dryRun"?: boolean;

    /**  */
    @Expose()
    "checked"?: number;

    /**  */
    @Expose()
    "inSync"?: number;

    /**  */
    @Expose()
    "outOfSync"?: number;

    /**  */
    @Expose()
    "resynced"?: number;

    /**  */
    @Expose()
    "nativeOrdersRefreshed"?: number;

    /**  */
    @Expose()
    "overdue"?: number;

    /**  */
    "alertSent"?: boolean;

    /**  */
    "items"?: DataTracReconcileItem[];

    constructor(data: undefined | any = {}) {
        this["dryRun"] = data["dryRun"];
        this["checked"] = data["checked"];
        this["inSync"] = data["inSync"];
        this["outOfSync"] = data["outOfSync"];
        this["resynced"] = data["resynced"];
        this["nativeOrdersRefreshed"] = data["nativeOrdersRefreshed"];
        this["overdue"] = data["overdue"];
        this["alertSent"] = data["alertSent"];
        this["items"] = data["items"];
    }

    public static validationModel = {};
}

export class DataTracReconcileResultDetailedResponse {
    /**  */
    "data"?: DataTracReconcileResult;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class Docket {
    /**  */
    "basicCaseInformation"?: DocketBasicCaseInformation;

    /**  */
    "courtEvents"?: DocketCourtEvent[];

    /**  */
    "documents"?: DocketDocument[];

    /**  */
    "parties"?: DocketParty[];

    /**  */
    @Expose()
    @Type(() => Date)
    "lastUpdated"?: Date;

    constructor(data: undefined | any = {}) {
        this["basicCaseInformation"] = data["basicCaseInformation"];
        this["courtEvents"] = data["courtEvents"];
        this["documents"] = data["documents"];
        this["parties"] = data["parties"];
        this["lastUpdated"] = data["lastUpdated"];
    }

    public static validationModel = {};
}

export class DocketBasicCaseInformation {
    /**  */
    "state"?: string;

    /**  */
    "county"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    "judge"?: string;

    /**  */
    "caseStatus"?: string;

    /**  */
    "filedDate"?: string;

    constructor(data: undefined | any = {}) {
        this["state"] = data["state"];
        this["county"] = data["county"];
        this["caseNumber"] = data["caseNumber"];
        this["ucn"] = data["ucn"];
        this["judge"] = data["judge"];
        this["caseStatus"] = data["caseStatus"];
        this["filedDate"] = data["filedDate"];
    }

    public static validationModel = {};
}

export class DocketCourtEvent {
    /**  */
    "eventType"?: string;

    /**  */
    "date"?: string;

    /**  */
    "eventJudge"?: string;

    /**  */
    "location"?: string;

    constructor(data: undefined | any = {}) {
        this["eventType"] = data["eventType"];
        this["date"] = data["date"];
        this["eventJudge"] = data["eventJudge"];
        this["location"] = data["location"];
    }

    public static validationModel = {};
}

export class DocketDetailedResponse {
    /**  */
    "data"?: Docket;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class DocketDocument {
    /**  */
    "filename"?: string;

    /**  */
    "documentType"?: string;

    /**  */
    "downloadLink"?: string;

    /**  */
    "date"?: string;

    constructor(data: undefined | any = {}) {
        this["filename"] = data["filename"];
        this["documentType"] = data["documentType"];
        this["downloadLink"] = data["downloadLink"];
        this["date"] = data["date"];
    }

    public static validationModel = {};
}

export class DocketParty {
    /**  */
    "role"?: string;

    /**  */
    "name"?: string;

    constructor(data: undefined | any = {}) {
        this["role"] = data["role"];
        this["name"] = data["name"];
    }

    public static validationModel = {};
}

export class Document {
    /**  */
    "documentTypeID"?: string;

    /**  */
    "documentType"?: string;

    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "filingCodeID"?: string;

    /**  */
    @Expose()
    "securityID"?: string;

    /**  */
    @Expose()
    "filingComponentID"?: string;

    /**  */
    "predictedType"?: string;

    /**  */
    "predictedTypeID"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "referenceNumber"?: string;

    /**  */
    "description"?: string;

    /**  */
    @Expose()
    "pageCount"?: number;

    /**  */
    "addresses"?: string[];

    /**  */
    "entities"?: string[];

    /**  */
    "comments"?: string;

    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "confidential"?: boolean;

    /**  */
    "documentGroup"?: string;

    /**  */
    "status"?: string;

    /**  */
    "downloadCopyUrl"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "statusUpdatedDate"?: Date;

    /**  */
    "statusUpdatedReason"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "dateServed"?: Date;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    @Expose()
    "size"?: number;

    /**  */
    "fees"?: Fee[];

    /**  */
    @Expose()
    "parentID"?: string;

    /**  */
    "parent"?: Document;

    /**  */
    "optionalServices"?: OptionalServicesCode[];

    /**  */
    "attachments"?: Document[];

    /**  */
    "filingCode"?: string;

    /**  */
    "detectedParties"?: Party[];

    /**  */
    "detectedAddresses"?: Address[];

    /**  */
    "metadata"?: object;

    constructor(data: undefined | any = {}) {
        this["documentTypeID"] = data["documentTypeID"];
        this["documentType"] = data["documentType"];
        this["filename"] = data["filename"];
        this["filingCodeID"] = data["filingCodeID"];
        this["securityID"] = data["securityID"];
        this["filingComponentID"] = data["filingComponentID"];
        this["predictedType"] = data["predictedType"];
        this["predictedTypeID"] = data["predictedTypeID"];
        this["submissionID"] = data["submissionID"];
        this["referenceNumber"] = data["referenceNumber"];
        this["description"] = data["description"];
        this["pageCount"] = data["pageCount"];
        this["addresses"] = data["addresses"];
        this["entities"] = data["entities"];
        this["comments"] = data["comments"];
        this["id"] = data["id"];
        this["confidential"] = data["confidential"];
        this["documentGroup"] = data["documentGroup"];
        this["status"] = data["status"];
        this["downloadCopyUrl"] = data["downloadCopyUrl"];
        this["statusUpdatedDate"] = data["statusUpdatedDate"];
        this["statusUpdatedReason"] = data["statusUpdatedReason"];
        this["dateServed"] = data["dateServed"];
        this["fee"] = data["fee"];
        this["size"] = data["size"];
        this["fees"] = data["fees"];
        this["parentID"] = data["parentID"];
        this["parent"] = data["parent"];
        this["optionalServices"] = data["optionalServices"];
        this["attachments"] = data["attachments"];
        this["filingCode"] = data["filingCode"];
        this["detectedParties"] = data["detectedParties"];
        this["detectedAddresses"] = data["detectedAddresses"];
        this["metadata"] = data["metadata"];
    }

    public static validationModel = {};
}

export class DocumentAPIResponse {
    /**  */
    "data"?: Document;

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class DocumentDetailedResponse {
    /**  */
    "data"?: Document;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class DocumentIEnumerableAPIResponse {
    /**  */
    "data"?: Document[];

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class DocumentListDetailedResponse {
    /**  */
    "data"?: Document[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class DoubleFileStatus {
    /**  */
    "referenceNumber"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "caseTitle"?: string;

    /**  */
    "reason"?: string;

    /**  */
    "statusText"?: string;

    /**  */
    "description"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "statusChangeDate"?: Date;

    /**  */
    @Expose()
    "key"?: number;

    /**  */
    "downloadUrl"?: string;

    /**  */
    "stampedCopyFilename"?: string;

    constructor(data: undefined | any = {}) {
        this["referenceNumber"] = data["referenceNumber"];
        this["caseNumber"] = data["caseNumber"];
        this["caseTitle"] = data["caseTitle"];
        this["reason"] = data["reason"];
        this["statusText"] = data["statusText"];
        this["description"] = data["description"];
        this["statusChangeDate"] = data["statusChangeDate"];
        this["key"] = data["key"];
        this["downloadUrl"] = data["downloadUrl"];
        this["stampedCopyFilename"] = data["stampedCopyFilename"];
    }

    public static validationModel = {};
}

export class DoubleFileStatusDetailedResponse {
    /**  */
    "data"?: DoubleFileStatus;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class EFMESystemSettings {
    /**  */
    @Expose()
    @Type(() => Date)
    "maxDisplayedDateTime"?: Date;

    /**  */
    "hiddenAttorneyIds"?: string[];

    /**  */
    "visibleAttorneyIds"?: string[];

    /**  */
    @Expose()
    "id"?: string;

    constructor(data: undefined | any = {}) {
        this["maxDisplayedDateTime"] = data["maxDisplayedDateTime"];
        this["hiddenAttorneyIds"] = data["hiddenAttorneyIds"];
        this["visibleAttorneyIds"] = data["visibleAttorneyIds"];
        this["id"] = data["id"];
    }

    public static validationModel = {};
}

export class EFMESystemSettingsDetailedResponse {
    /**  */
    "data"?: EFMESystemSettings;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class EFileRecentReportRow {
    /**  */
    @Expose()
    @Type(() => Date)
    "DATE"?: Date;

    /**  */
    "PROCESS"?: string;

    /**  */
    "ATTORNEY"?: string;

    /**  */
    "FILENAME"?: string;

    constructor(data: undefined | any = {}) {
        this["DATE"] = data["DATE"];
        this["PROCESS"] = data["PROCESS"];
        this["ATTORNEY"] = data["ATTORNEY"];
        this["FILENAME"] = data["FILENAME"];
    }

    public static validationModel = {};
}

export class EFileRecentReportRowListDetailedResponse {
    /**  */
    "data"?: EFileRecentReportRow[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class EFileReportRequest {
    /**  */
    "fromDate"?: string;

    /**  */
    "toDate"?: string;

    /**  */
    @Expose()
    "searchBy"?: number;

    /**  */
    "contains"?: string;

    constructor(data: undefined | any = {}) {
        this["fromDate"] = data["fromDate"];
        this["toDate"] = data["toDate"];
        this["searchBy"] = data["searchBy"];
        this["contains"] = data["contains"];
    }

    public static validationModel = {};
}

export class EFileReportRow {
    /**  */
    "NO"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "EFME_STATUS"?: string;

    /**  */
    "CRT_CASE_NO"?: string;

    /**  */
    "UCN"?: string;

    /**  */
    "PARTIES"?: string;

    /**  */
    @Expose()
    "NO_DOCS_FILED"?: number;

    /**  */
    @Expose()
    @Type(() => Date)
    "DATE_FILED"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "DATE_UPLOADED"?: Date;

    /**  */
    "PORTAL_REF_NO"?: string;

    /**  */
    "ATTORNEY"?: string;

    /**  */
    "FILENAME"?: string;

    /**  */
    "COUNTY"?: string;

    /**  */
    "DIVISION"?: string;

    /**  */
    "TRACKING"?: string;

    /**  */
    "SERVICE"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "REVIEWED_DATE"?: Date;

    /**  */
    "NOTES"?: string;

    /**  */
    "TYPE"?: string;

    /**  */
    "PORTAL_STATUS"?: string;

    /**  */
    "FINALFEES"?: string;

    constructor(data: undefined | any = {}) {
        this["NO"] = data["NO"];
        this["attorneyID"] = data["attorneyID"];
        this["EFME_STATUS"] = data["EFME_STATUS"];
        this["CRT_CASE_NO"] = data["CRT_CASE_NO"];
        this["UCN"] = data["UCN"];
        this["PARTIES"] = data["PARTIES"];
        this["NO_DOCS_FILED"] = data["NO_DOCS_FILED"];
        this["DATE_FILED"] = data["DATE_FILED"];
        this["DATE_UPLOADED"] = data["DATE_UPLOADED"];
        this["PORTAL_REF_NO"] = data["PORTAL_REF_NO"];
        this["ATTORNEY"] = data["ATTORNEY"];
        this["FILENAME"] = data["FILENAME"];
        this["COUNTY"] = data["COUNTY"];
        this["DIVISION"] = data["DIVISION"];
        this["TRACKING"] = data["TRACKING"];
        this["SERVICE"] = data["SERVICE"];
        this["REVIEWED_DATE"] = data["REVIEWED_DATE"];
        this["NOTES"] = data["NOTES"];
        this["TYPE"] = data["TYPE"];
        this["PORTAL_STATUS"] = data["PORTAL_STATUS"];
        this["FINALFEES"] = data["FINALFEES"];
    }

    public static validationModel = {};
}

export class EFileReportRowListDetailedResponse {
    /**  */
    "data"?: EFileReportRow[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class Email {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "emailAddress"?: string;

    /**  */
    "name"?: string;

    /**  */
    "source"?: string;

    /**  */
    "filingService"?: boolean;

    /**  */
    "acceptedService"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["emailAddress"] = data["emailAddress"];
        this["name"] = data["name"];
        this["source"] = data["source"];
        this["filingService"] = data["filingService"];
        this["acceptedService"] = data["acceptedService"];
    }

    public static validationModel = {};
}

export class EmailDetailedResponse {
    /**  */
    "data"?: Email;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class EmailListDetailedResponse {
    /**  */
    "data"?: Email[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class EmailReceipt {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "to"?: string;

    /**  */
    "bcc"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "sent"?: Date;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["to"] = data["to"];
        this["bcc"] = data["bcc"];
        this["sent"] = data["sent"];
    }

    public static validationModel = {};
}

export class EmailReceiptAPIResponse {
    /**  */
    "data"?: EmailReceipt;

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class EmailReceiptIEnumerableAPIResponse {
    /**  */
    "data"?: EmailReceipt[];

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class EmailReceiptListDetailedResponse {
    /**  */
    "data"?: EmailReceipt[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class EmailRequest {
    /**  */
    "emailAddress"?: string;

    /**  */
    "name"?: string;

    constructor(data: undefined | any = {}) {
        this["emailAddress"] = data["emailAddress"];
        this["name"] = data["name"];
    }

    public static validationModel = {};
}

export class ErrorUploadingRequest {
    /**  */
    "reason"?: string;

    constructor(data: undefined | any = {}) {
        this["reason"] = data["reason"];
    }

    public static validationModel = {};
}

export class Exhibits {
    /**  */
    @Expose()
    "attachmentOptionKey"?: number;

    /**  */
    @Expose()
    "seperatorOptionKey"?: number;

    /**  */
    "filenames"?: string[];

    constructor(data: undefined | any = {}) {
        this["attachmentOptionKey"] = data["attachmentOptionKey"];
        this["seperatorOptionKey"] = data["seperatorOptionKey"];
        this["filenames"] = data["filenames"];
    }

    public static validationModel = {};
}

export class Fee {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "description"?: string;

    /**  */
    @Expose()
    "amount"?: number;

    /**  */
    @Expose()
    "quantity"?: number;

    /**  */
    "ePortalID"?: string;

    /**  */
    "source"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "recordedDate"?: Date;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["description"] = data["description"];
        this["amount"] = data["amount"];
        this["quantity"] = data["quantity"];
        this["ePortalID"] = data["ePortalID"];
        this["source"] = data["source"];
        this["recordedDate"] = data["recordedDate"];
    }

    public static validationModel = {};
}

export class FeeLine {
    /**  */
    "description"?: string;

    /**  */
    @Expose()
    "amount"?: number;

    /**  */
    @Expose()
    "quantity"?: number;

    /**  */
    "ePortalID"?: string;

    constructor(data: undefined | any = {}) {
        this["description"] = data["description"];
        this["amount"] = data["amount"];
        this["quantity"] = data["quantity"];
        this["ePortalID"] = data["ePortalID"];
    }

    public static validationModel = {};
}

export class FeeListDetailedResponse {
    /**  */
    "data"?: Fee[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class FilingStatusReportFilter {
    /**  */
    @Expose()
    "attorneyId"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "submittedSince"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "submittedUntil"?: Date;

    /**  */
    "status"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "statusUpdatedSince"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "statusUpdatedUntil"?: Date;

    constructor(data: undefined | any = {}) {
        this["attorneyId"] = data["attorneyId"];
        this["submittedSince"] = data["submittedSince"];
        this["submittedUntil"] = data["submittedUntil"];
        this["status"] = data["status"];
        this["statusUpdatedSince"] = data["statusUpdatedSince"];
        this["statusUpdatedUntil"] = data["statusUpdatedUntil"];
    }

    public static validationModel = {};
}

export class Firm {
    /**  */
    @Expose()
    "v1_ID"?: number;

    /**  */
    "name"?: string;

    /**  */
    "processPendingQueue"?: boolean;

    /**  */
    "monitorPendingQueue"?: boolean;

    /**  */
    "pendingQueueEmail"?: string;

    /**  */
    "useDocumentEmails"?: boolean;

    /**  */
    "usePortalEmails"?: boolean;

    /**  */
    "serveThroughPortal"?: boolean;

    /**  */
    "noService"?: boolean;

    /**  */
    "noPortalService"?: boolean;

    /**  */
    "controlNumberInFilename"?: boolean;

    /**  */
    "holdIncoming"?: boolean;

    /**  */
    "allowOCR"?: boolean;

    /**  */
    "autoFileExisting"?: boolean;

    /**  */
    "autoFileNew"?: boolean;

    /**  */
    "address"?: Address;

    /**  */
    "active"?: boolean;

    constructor(data: undefined | any = {}) {
        this["v1_ID"] = data["v1_ID"];
        this["name"] = data["name"];
        this["processPendingQueue"] = data["processPendingQueue"];
        this["monitorPendingQueue"] = data["monitorPendingQueue"];
        this["pendingQueueEmail"] = data["pendingQueueEmail"];
        this["useDocumentEmails"] = data["useDocumentEmails"];
        this["usePortalEmails"] = data["usePortalEmails"];
        this["serveThroughPortal"] = data["serveThroughPortal"];
        this["noService"] = data["noService"];
        this["noPortalService"] = data["noPortalService"];
        this["controlNumberInFilename"] = data["controlNumberInFilename"];
        this["holdIncoming"] = data["holdIncoming"];
        this["allowOCR"] = data["allowOCR"];
        this["autoFileExisting"] = data["autoFileExisting"];
        this["autoFileNew"] = data["autoFileNew"];
        this["address"] = data["address"];
        this["active"] = data["active"];
    }

    public static validationModel = {};
}

export class GeneratedDocument {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "submission"?: Submission;

    /**  */
    "path"?: string;

    /**  */
    "sendTo"?: string;

    /**  */
    "generated"?: boolean;

    /**  */
    "generatedFields"?: GeneratedField[];

    /**  */
    @Expose()
    @Type(() => Date)
    "updatedDate"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "createdDate"?: Date;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["submission"] = data["submission"];
        this["path"] = data["path"];
        this["sendTo"] = data["sendTo"];
        this["generated"] = data["generated"];
        this["generatedFields"] = data["generatedFields"];
        this["updatedDate"] = data["updatedDate"];
        this["createdDate"] = data["createdDate"];
    }

    public static validationModel = {};
}

export class GeneratedDocumentAPIResponse {
    /**  */
    "data"?: GeneratedDocument;

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class GeneratedDocumentIEnumerableAPIResponse {
    /**  */
    "data"?: GeneratedDocument[];

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class GeneratedDocumentListDetailedResponse {
    /**  */
    "data"?: GeneratedDocument[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class GeneratedDocumentPagedResult {
    /**  */
    "data"?: GeneratedDocument[];

    /**  */
    @Expose()
    "totalCount"?: number;

    /**  */
    @Expose()
    "currentPage"?: number;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["totalCount"] = data["totalCount"];
        this["currentPage"] = data["currentPage"];
    }

    public static validationModel = {};
}

export class GeneratedDocumentPagedResultDetailedResponse {
    /**  */
    "data"?: GeneratedDocumentPagedResult;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class GeneratedField {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "value"?: string;

    /**  */
    @Expose()
    "xPos"?: number;

    /**  */
    @Expose()
    "yPos"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["value"] = data["value"];
        this["xPos"] = data["xPos"];
        this["yPos"] = data["yPos"];
    }

    public static validationModel = {};
}

export class GuidDetailedResponse {
    /**  */
    @Expose()
    "data"?: string;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class GuidListDetailedResponse {
    /**  */
    "data"?: string[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class HoldRetryRequest {
    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "fromDateTime"?: Date;

    /**  */
    "state"?: string;

    /**  */
    "queryFilename"?: string;

    /**  */
    "queryMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["attorneyID"] = data["attorneyID"];
        this["fromDateTime"] = data["fromDateTime"];
        this["state"] = data["state"];
        this["queryFilename"] = data["queryFilename"];
        this["queryMessage"] = data["queryMessage"];
    }

    public static validationModel = {};
}

export class IFileInfo {
    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "size"?: number;

    /**  */
    @Expose()
    @Type(() => Date)
    "lastUpdatedDateTime"?: Date;

    constructor(data: undefined | any = {}) {
        this["filename"] = data["filename"];
        this["size"] = data["size"];
        this["lastUpdatedDateTime"] = data["lastUpdatedDateTime"];
    }

    public static validationModel = {};
}

export class IFileInfoIEnumerableDetailedResponse {
    /**  */
    "data"?: IFileInfo[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class IPortalConfiguration {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "state"?: string;

    /**  */
    "portalIdentifier"?: string;

    /**  */
    "credentialHash"?: string;

    /**  */
    "paymentToken"?: string;

    /**  */
    "cvv"?: string;

    /**  */
    "displayName"?: string;

    /**  */
    "authCookieString"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["state"] = data["state"];
        this["portalIdentifier"] = data["portalIdentifier"];
        this["credentialHash"] = data["credentialHash"];
        this["paymentToken"] = data["paymentToken"];
        this["cvv"] = data["cvv"];
        this["displayName"] = data["displayName"];
        this["authCookieString"] = data["authCookieString"];
    }

    public static validationModel = {};
}

export class IgnoreService {
    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "notes"?: string;

    constructor(data: undefined | any = {}) {
        this["submissionID"] = data["submissionID"];
        this["notes"] = data["notes"];
    }

    public static validationModel = {};
}

export class ImportRequest {
    /**  */
    "path"?: string;

    constructor(data: undefined | any = {}) {
        this["path"] = data["path"];
    }

    public static validationModel = {};
}

export class Int32ArrayNameValue {
    /**  */
    "name"?: string;

    /**  */
    "value"?: number[];

    constructor(data: undefined | any = {}) {
        this["name"] = data["name"];
        this["value"] = data["value"];
    }

    public static validationModel = {};
}

export class Int32DetailedResponse {
    /**  */
    @Expose()
    "data"?: number;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class Int32NameValue {
    /**  */
    "name"?: string;

    /**  */
    @Expose()
    "value"?: number;

    constructor(data: undefined | any = {}) {
        this["name"] = data["name"];
        this["value"] = data["value"];
    }

    public static validationModel = {};
}

export class NewCase {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "uploadTypeKey"?: number;

    /**  */
    @Expose()
    "userID"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "coversheet"?: Coversheet;

    /**  */
    "exhibits"?: Exhibits;

    /**  */
    "submittedBy"?: string;

    /**  */
    "documents"?: Document[];

    /**  */
    "filenames"?: string[];

    /**  */
    "fileAsIndividuals"?: boolean;

    /**  */
    "emergency"?: boolean;

    /**  */
    "matterNumber"?: string;

    /**  */
    "notes"?: string;

    /**  */
    "hasFees"?: boolean;

    /**  */
    "hasWaiver"?: boolean;

    /**  */
    @Expose()
    "serveWithSubmissionID"?: string;

    /**  */
    "filingParty"?: string;

    /**  */
    "flcEmail"?: string;

    /**  */
    @Expose()
    "eServiceOption"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["uploadTypeKey"] = data["uploadTypeKey"];
        this["userID"] = data["userID"];
        this["attorneyID"] = data["attorneyID"];
        this["attorneyName"] = data["attorneyName"];
        this["filename"] = data["filename"];
        this["coversheet"] = data["coversheet"];
        this["exhibits"] = data["exhibits"];
        this["submittedBy"] = data["submittedBy"];
        this["documents"] = data["documents"];
        this["filenames"] = data["filenames"];
        this["fileAsIndividuals"] = data["fileAsIndividuals"];
        this["emergency"] = data["emergency"];
        this["matterNumber"] = data["matterNumber"];
        this["notes"] = data["notes"];
        this["hasFees"] = data["hasFees"];
        this["hasWaiver"] = data["hasWaiver"];
        this["serveWithSubmissionID"] = data["serveWithSubmissionID"];
        this["filingParty"] = data["filingParty"];
        this["flcEmail"] = data["flcEmail"];
        this["eServiceOption"] = data["eServiceOption"];
    }

    public static validationModel = {};
}

export class Notes {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "note"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["note"] = data["note"];
    }

    public static validationModel = {};
}

export class OptionalServicesCode {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    @Expose()
    "fee"?: number;

    /**  */
    "multiplier"?: boolean;

    /**  */
    @Expose()
    "quantity"?: number;

    /**  */
    "filingCode"?: string;

    /**  */
    @Expose()
    "displayOrder"?: number;

    /**  */
    "allowMultiplier"?: boolean;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "ePortalId"?: string;

    /**  */
    "code"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["fee"] = data["fee"];
        this["multiplier"] = data["multiplier"];
        this["quantity"] = data["quantity"];
        this["filingCode"] = data["filingCode"];
        this["displayOrder"] = data["displayOrder"];
        this["allowMultiplier"] = data["allowMultiplier"];
        this["countyID"] = data["countyID"];
        this["ePortalId"] = data["ePortalId"];
        this["code"] = data["code"];
    }

    public static validationModel = {};
}

export class Order {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "uploadTypeKey"?: number;

    /**  */
    @Expose()
    "userID"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "judicialOfficerID"?: string;

    /**  */
    "exhibits"?: Exhibits;

    /**  */
    "submittedBy"?: string;

    /**  */
    "documents"?: Document[];

    /**  */
    "filenames"?: string[];

    /**  */
    "fileAsIndividuals"?: boolean;

    /**  */
    "emergency"?: boolean;

    /**  */
    "matterNumber"?: string;

    /**  */
    @Expose()
    "serveWithSubmissionID"?: string;

    /**  */
    "filingParty"?: string;

    /**  */
    "flcEmail"?: string;

    /**  */
    @Expose()
    "eServiceOption"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["uploadTypeKey"] = data["uploadTypeKey"];
        this["userID"] = data["userID"];
        this["attorneyID"] = data["attorneyID"];
        this["attorneyName"] = data["attorneyName"];
        this["filename"] = data["filename"];
        this["judicialOfficerID"] = data["judicialOfficerID"];
        this["exhibits"] = data["exhibits"];
        this["submittedBy"] = data["submittedBy"];
        this["documents"] = data["documents"];
        this["filenames"] = data["filenames"];
        this["fileAsIndividuals"] = data["fileAsIndividuals"];
        this["emergency"] = data["emergency"];
        this["matterNumber"] = data["matterNumber"];
        this["serveWithSubmissionID"] = data["serveWithSubmissionID"];
        this["filingParty"] = data["filingParty"];
        this["flcEmail"] = data["flcEmail"];
        this["eServiceOption"] = data["eServiceOption"];
    }

    public static validationModel = {};
}

export class OrderFiling {
    /**  */
    "filingCode"?: string;

    /**  */
    "description"?: string;

    /**  */
    "notes"?: string;

    /**  */
    "downloadUrl"?: string;

    /**  */
    "isLeadDocument"?: boolean;

    constructor(data: undefined | any = {}) {
        this["filingCode"] = data["filingCode"];
        this["description"] = data["description"];
        this["notes"] = data["notes"];
        this["downloadUrl"] = data["downloadUrl"];
        this["isLeadDocument"] = data["isLeadDocument"];
    }

    public static validationModel = {};
}

export class OrderReceipt {
    /**  */
    "orderId"?: string;

    /**  */
    "status"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "receivedAt"?: Date;

    constructor(data: undefined | any = {}) {
        this["orderId"] = data["orderId"];
        this["status"] = data["status"];
        this["receivedAt"] = data["receivedAt"];
    }

    public static validationModel = {};
}

export class OrderReceiptDetailedResponse {
    /**  */
    "data"?: OrderReceipt;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class OrderRequest {
    /**  */
    "orderId"?: string;

    /**  */
    "submittedById"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    @Expose()
    "eServiceOption"?: number;

    /**  */
    "filingParty"?: string;

    /**  */
    "caseData"?: UploadCaseData;

    /**  */
    "filings"?: OrderFiling[];

    /**  */
    "notes"?: string;

    constructor(data: undefined | any = {}) {
        this["orderId"] = data["orderId"];
        this["submittedById"] = data["submittedById"];
        this["attorneyName"] = data["attorneyName"];
        this["eServiceOption"] = data["eServiceOption"];
        this["filingParty"] = data["filingParty"];
        this["caseData"] = data["caseData"];
        this["filings"] = data["filings"];
        this["notes"] = data["notes"];
    }

    public static validationModel = {};
}

export class Party {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "name"?: string;

    /**  */
    "partyType"?: string;

    /**  */
    "firstName"?: string;

    /**  */
    "middleName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "partyTypeCode"?: string;

    /**  */
    "emailAddress"?: string;

    /**  */
    "phoneNumber"?: string;

    /**  */
    "barNumber"?: string;

    /**  */
    "username"?: string;

    /**  */
    @Expose()
    "addressID"?: string;

    /**  */
    "address"?: Address;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "attorney"?: Attorney;

    /**  */
    "isLeadAttorney"?: boolean;

    /**  */
    "guid"?: string;

    /**  */
    "portalID"?: string;

    /**  */
    "associateWithFilingParties"?: boolean;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["name"] = data["name"];
        this["partyType"] = data["partyType"];
        this["firstName"] = data["firstName"];
        this["middleName"] = data["middleName"];
        this["lastName"] = data["lastName"];
        this["partyTypeCode"] = data["partyTypeCode"];
        this["emailAddress"] = data["emailAddress"];
        this["phoneNumber"] = data["phoneNumber"];
        this["barNumber"] = data["barNumber"];
        this["username"] = data["username"];
        this["addressID"] = data["addressID"];
        this["address"] = data["address"];
        this["attorneyID"] = data["attorneyID"];
        this["attorney"] = data["attorney"];
        this["isLeadAttorney"] = data["isLeadAttorney"];
        this["guid"] = data["guid"];
        this["portalID"] = data["portalID"];
        this["associateWithFilingParties"] = data["associateWithFilingParties"];
    }

    public static validationModel = {};
}

export class PartyDetailedResponse {
    /**  */
    "data"?: Party;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class PartyListDetailedResponse {
    /**  */
    "data"?: Party[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class PartyRequest {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "name"?: string;

    /**  */
    "partyType"?: string;

    /**  */
    "firstName"?: string;

    /**  */
    "middleName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "streetAddress"?: string;

    /**  */
    "unit"?: string;

    /**  */
    "city"?: string;

    /**  */
    "state"?: string;

    /**  */
    "postal"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["name"] = data["name"];
        this["partyType"] = data["partyType"];
        this["firstName"] = data["firstName"];
        this["middleName"] = data["middleName"];
        this["lastName"] = data["lastName"];
        this["streetAddress"] = data["streetAddress"];
        this["unit"] = data["unit"];
        this["city"] = data["city"];
        this["state"] = data["state"];
        this["postal"] = data["postal"];
    }

    public static validationModel = {};
}

export class PendingServiceDocument {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "filedDateTime"?: Date;

    /**  */
    @Expose()
    "documentsRequiringService"?: number;

    /**  */
    @Expose()
    "missingDocuments"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["attorneyID"] = data["attorneyID"];
        this["attorneyName"] = data["attorneyName"];
        this["ucn"] = data["ucn"];
        this["filedDateTime"] = data["filedDateTime"];
        this["documentsRequiringService"] = data["documentsRequiringService"];
        this["missingDocuments"] = data["missingDocuments"];
    }

    public static validationModel = {};
}

export class PendingServiceDocumentListDetailedResponse {
    /**  */
    "data"?: PendingServiceDocument[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class PortalConfiguration {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "state"?: string;

    /**  */
    "portalIdentifier"?: string;

    /**  */
    "credentialHash"?: string;

    /**  */
    "paymentToken"?: string;

    /**  */
    "cvv"?: string;

    /**  */
    "displayName"?: string;

    /**  */
    "authCookieString"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["state"] = data["state"];
        this["portalIdentifier"] = data["portalIdentifier"];
        this["credentialHash"] = data["credentialHash"];
        this["paymentToken"] = data["paymentToken"];
        this["cvv"] = data["cvv"];
        this["displayName"] = data["displayName"];
        this["authCookieString"] = data["authCookieString"];
    }

    public static validationModel = {};
}

export class PresignedUploadRequest {
    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "fileSizeBytes"?: number;

    /**  */
    @Expose()
    "actingUserId"?: string;

    constructor(data: undefined | any = {}) {
        this["filename"] = data["filename"];
        this["fileSizeBytes"] = data["fileSizeBytes"];
        this["actingUserId"] = data["actingUserId"];
    }

    public static validationModel = {};
}

export class ProgressResult {
    /**  */
    @Expose()
    "total"?: number;

    /**  */
    @Expose()
    "progress"?: number;

    constructor(data: undefined | any = {}) {
        this["total"] = data["total"];
        this["progress"] = data["progress"];
    }

    public static validationModel = {};
}

export class QueueCount {
    /**  */
    @Expose()
    "existing"?: number;

    /**  */
    @Expose()
    "newCases"?: number;

    /**  */
    @Expose()
    "dfs"?: number;

    /**  */
    @Expose()
    "hold"?: number;

    /**  */
    @Expose()
    "orders"?: number;

    /**  */
    @Expose()
    "total"?: number;

    constructor(data: undefined | any = {}) {
        this["existing"] = data["existing"];
        this["newCases"] = data["newCases"];
        this["dfs"] = data["dfs"];
        this["hold"] = data["hold"];
        this["orders"] = data["orders"];
        this["total"] = data["total"];
    }

    public static validationModel = {};
}

export class QueueCountDetailedResponse {
    /**  */
    "data"?: QueueCount;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class QueuedSubmission {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "legacyID"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "statusID"?: string;

    /**  */
    "statusDescription"?: string;

    /**  */
    "statusReason"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "uploadedDateTime"?: Date;

    /**  */
    "emergency"?: boolean;

    /**  */
    "autoFile"?: boolean;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    "courtCaseNumber"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["legacyID"] = data["legacyID"];
        this["filename"] = data["filename"];
        this["statusID"] = data["statusID"];
        this["statusDescription"] = data["statusDescription"];
        this["statusReason"] = data["statusReason"];
        this["uploadedDateTime"] = data["uploadedDateTime"];
        this["emergency"] = data["emergency"];
        this["autoFile"] = data["autoFile"];
        this["attorneyID"] = data["attorneyID"];
        this["attorneyName"] = data["attorneyName"];
        this["courtCaseNumber"] = data["courtCaseNumber"];
    }

    public static validationModel = {};
}

export class QueuedSubmissionListAPIResponse {
    /**  */
    "data"?: QueuedSubmission[];

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class QueuedSubmissionListDetailedResponse {
    /**  */
    "data"?: QueuedSubmission[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class RejectedRequest {
    /**  */
    @Expose()
    @Type(() => Date)
    "rejectedDateTime"?: Date;

    /**  */
    "reason"?: string;

    constructor(data: undefined | any = {}) {
        this["rejectedDateTime"] = data["rejectedDateTime"];
        this["reason"] = data["reason"];
    }

    public static validationModel = {};
}

export class ReportSubmission {
    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "matterNumber"?: string;

    /**  */
    "statusDescription"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    "referenceNumber"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "uploadedDateTime"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "filedDateTime"?: Date;

    constructor(data: undefined | any = {}) {
        this["submissionID"] = data["submissionID"];
        this["filename"] = data["filename"];
        this["caseNumber"] = data["caseNumber"];
        this["matterNumber"] = data["matterNumber"];
        this["statusDescription"] = data["statusDescription"];
        this["attorneyName"] = data["attorneyName"];
        this["referenceNumber"] = data["referenceNumber"];
        this["uploadedDateTime"] = data["uploadedDateTime"];
        this["filedDateTime"] = data["filedDateTime"];
    }

    public static validationModel = {};
}

export class ReportSubmissionPagedResult {
    /**  */
    "data"?: ReportSubmission[];

    /**  */
    @Expose()
    "totalCount"?: number;

    /**  */
    @Expose()
    "currentPage"?: number;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["totalCount"] = data["totalCount"];
        this["currentPage"] = data["currentPage"];
    }

    public static validationModel = {};
}

export class ReportingRequest {
    /**  */
    @Expose()
    "userID"?: string;

    /**  */
    @Expose()
    "pageNumber"?: number;

    /**  */
    @Expose()
    "itemsPerPage"?: number;

    /**  */
    "searchString"?: string;

    /**  */
    "orderBy"?: string;

    /**  */
    "orderDirection"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "startDate"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "endDate"?: Date;

    /**  */
    "keyword"?: string;

    /**  */
    "_filterKey"?: SubmissionReportFilterKeys;

    constructor(data: undefined | any = {}) {
        this["userID"] = data["userID"];
        this["pageNumber"] = data["pageNumber"];
        this["itemsPerPage"] = data["itemsPerPage"];
        this["searchString"] = data["searchString"];
        this["orderBy"] = data["orderBy"];
        this["orderDirection"] = data["orderDirection"];
        this["startDate"] = data["startDate"];
        this["endDate"] = data["endDate"];
        this["keyword"] = data["keyword"];
        this["_filterKey"] = data["_filterKey"];
    }

    public static validationModel = {};
}

export class ServedRequest {
    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "portalServed"?: boolean;

    /**  */
    "toEmails"?: string[];

    constructor(data: undefined | any = {}) {
        this["submissionID"] = data["submissionID"];
        this["portalServed"] = data["portalServed"];
        this["toEmails"] = data["toEmails"];
    }

    public static validationModel = {};
}

export class ServiceRequest {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    "serviceDocumentRegex"?: string;

    /**  */
    "complete"?: boolean;

    /**  */
    @Expose()
    @Type(() => Date)
    "expirationDate"?: Date;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["ucn"] = data["ucn"];
        this["serviceDocumentRegex"] = data["serviceDocumentRegex"];
        this["complete"] = data["complete"];
        this["expirationDate"] = data["expirationDate"];
    }

    public static validationModel = {};
}

export class ServiceRequestDetailedResponse {
    /**  */
    "data"?: ServiceRequest;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class ServiceRequestListDetailedResponse {
    /**  */
    "data"?: ServiceRequest[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class ServiceSuitData {
    /**  */
    "caseData"?: CaseData;

    /**  */
    "parties"?: Party[];

    /**  */
    "documents"?: Document[];

    constructor(data: undefined | any = {}) {
        this["caseData"] = data["caseData"];
        this["parties"] = data["parties"];
        this["documents"] = data["documents"];
    }

    public static validationModel = {};
}

export class ServiceSuitDataDetailedResponse {
    /**  */
    "data"?: ServiceSuitData;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class SplitDocument {
    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    @Expose()
    "userID"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "pages"?: SplitDocumentPage[];

    constructor(data: undefined | any = {}) {
        this["submissionID"] = data["submissionID"];
        this["userID"] = data["userID"];
        this["filename"] = data["filename"];
        this["pages"] = data["pages"];
    }

    public static validationModel = {};
}

export class SplitDocumentDetailedResponse {
    /**  */
    "data"?: SplitDocument;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class SplitDocumentPage {
    /**  */
    @Expose()
    "pageNumber"?: number;

    /**  */
    "pageType"?: string;

    constructor(data: undefined | any = {}) {
        this["pageNumber"] = data["pageNumber"];
        this["pageType"] = data["pageType"];
    }

    public static validationModel = {};
}

export class Status {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "description"?: string;

    /**  */
    @Expose()
    "key"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["description"] = data["description"];
        this["key"] = data["key"];
    }

    public static validationModel = {};
}

export class StringDetailedResponse {
    /**  */
    "data"?: string;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class Submission {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    @Expose()
    "fileID"?: number;

    /**  */
    "filename"?: string;

    /**  */
    "portalIdentifier"?: string;

    /**  */
    "emergency"?: boolean;

    /**  */
    "referenceNumber"?: string;

    /**  */
    @Expose()
    "priorityOrder"?: number;

    /**  */
    @Expose()
    "documentCount"?: number;

    /**  */
    "autoFile"?: boolean;

    /**  */
    "override"?: boolean;

    /**  */
    "feePay"?: boolean;

    /**  */
    "isProSe"?: boolean;

    /**  */
    "requiresFeeWaiver"?: boolean;

    /**  */
    @Expose()
    @Type(() => Date)
    "uploadedDateTime"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "filedDateTime"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "acceptedDateTime"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "rejectedDateTime"?: Date;

    /**  */
    @Expose()
    "statusID"?: string;

    /**  */
    "status"?: Status;

    /**  */
    "updatedBy"?: string;

    /**  */
    @Expose()
    "updatedByID"?: string;

    /**  */
    "updatedMessage"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "updatedDate"?: Date;

    /**  */
    "finalFees"?: string;

    /**  */
    "portalStatus"?: string;

    /**  */
    "caseData"?: CaseData;

    /**  */
    "attorney"?: Attorney;

    /**  */
    "emails"?: Email[];

    /**  */
    "parties"?: Party[];

    /**  */
    "documents"?: Document[];

    /**  */
    "addresses"?: Address[];

    /**  */
    "fees"?: Fee[];

    /**  */
    "notes"?: Notes[];

    /**  */
    "filingPartyID"?: string;

    /**  */
    "filingPartyIDs"?: string[];

    /**  */
    "filingAttorneyID"?: string;

    /**  */
    "generateCoverSheet"?: boolean;

    /**  */
    "submitterName"?: string;

    /**  */
    "portalConfiguration"?: IPortalConfiguration;

    /**  */
    @Expose()
    "uploadID"?: string;

    /**  */
    "upload"?: Upload;

    /**  */
    @Expose()
    "paymentMethodID"?: string;

    /**  */
    "eServiceOption"?: eServiceOptions;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["attorneyID"] = data["attorneyID"];
        this["fileID"] = data["fileID"];
        this["filename"] = data["filename"];
        this["portalIdentifier"] = data["portalIdentifier"];
        this["emergency"] = data["emergency"];
        this["referenceNumber"] = data["referenceNumber"];
        this["priorityOrder"] = data["priorityOrder"];
        this["documentCount"] = data["documentCount"];
        this["autoFile"] = data["autoFile"];
        this["override"] = data["override"];
        this["feePay"] = data["feePay"];
        this["isProSe"] = data["isProSe"];
        this["requiresFeeWaiver"] = data["requiresFeeWaiver"];
        this["uploadedDateTime"] = data["uploadedDateTime"];
        this["filedDateTime"] = data["filedDateTime"];
        this["acceptedDateTime"] = data["acceptedDateTime"];
        this["rejectedDateTime"] = data["rejectedDateTime"];
        this["statusID"] = data["statusID"];
        this["status"] = data["status"];
        this["updatedBy"] = data["updatedBy"];
        this["updatedByID"] = data["updatedByID"];
        this["updatedMessage"] = data["updatedMessage"];
        this["updatedDate"] = data["updatedDate"];
        this["finalFees"] = data["finalFees"];
        this["portalStatus"] = data["portalStatus"];
        this["caseData"] = data["caseData"];
        this["attorney"] = data["attorney"];
        this["emails"] = data["emails"];
        this["parties"] = data["parties"];
        this["documents"] = data["documents"];
        this["addresses"] = data["addresses"];
        this["fees"] = data["fees"];
        this["notes"] = data["notes"];
        this["filingPartyID"] = data["filingPartyID"];
        this["filingPartyIDs"] = data["filingPartyIDs"];
        this["filingAttorneyID"] = data["filingAttorneyID"];
        this["generateCoverSheet"] = data["generateCoverSheet"];
        this["submitterName"] = data["submitterName"];
        this["portalConfiguration"] = data["portalConfiguration"];
        this["uploadID"] = data["uploadID"];
        this["upload"] = data["upload"];
        this["paymentMethodID"] = data["paymentMethodID"];
        this["eServiceOption"] = data["eServiceOption"];
    }

    public static validationModel = {};
}

export class SubmissionAPIResponse {
    /**  */
    "data"?: Submission;

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class SubmissionDetailedResponse {
    /**  */
    "data"?: Submission;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class SubmissionFiling {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "court"?: string;

    /**  */
    "matterNumber"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "caseTitle"?: string;

    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "stampedCopyID"?: string;

    /**  */
    "referenceNumber"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "statusUpdatedDate"?: Date;

    /**  */
    "status"?: string;

    /**  */
    "reason"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["court"] = data["court"];
        this["matterNumber"] = data["matterNumber"];
        this["caseNumber"] = data["caseNumber"];
        this["caseTitle"] = data["caseTitle"];
        this["filename"] = data["filename"];
        this["stampedCopyID"] = data["stampedCopyID"];
        this["referenceNumber"] = data["referenceNumber"];
        this["statusUpdatedDate"] = data["statusUpdatedDate"];
        this["status"] = data["status"];
        this["reason"] = data["reason"];
    }

    public static validationModel = {};
}

export class SubmissionFilingPagedResult {
    /**  */
    "data"?: SubmissionFiling[];

    /**  */
    @Expose()
    "totalCount"?: number;

    /**  */
    @Expose()
    "currentPage"?: number;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["totalCount"] = data["totalCount"];
        this["currentPage"] = data["currentPage"];
    }

    public static validationModel = {};
}

export class SubmissionIEnumerableAPIResponse {
    /**  */
    "data"?: Submission[];

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class SubmissionIEnumerableDetailedResponse {
    /**  */
    "data"?: Submission[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class SubmissionListAPIResponse {
    /**  */
    "data"?: Submission[];

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class SubmissionListDetailedResponse {
    /**  */
    "data"?: Submission[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class SubmissionPagedResult {
    /**  */
    "data"?: Submission[];

    /**  */
    @Expose()
    "totalCount"?: number;

    /**  */
    @Expose()
    "currentPage"?: number;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["totalCount"] = data["totalCount"];
        this["currentPage"] = data["currentPage"];
    }

    public static validationModel = {};
}

export class SubmissionPagedResultAPIResponse {
    /**  */
    "data"?: SubmissionPagedResult;

    /**  */
    "successful"?: boolean;

    /**  */
    "message"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["message"] = data["message"];
    }

    public static validationModel = {};
}

export class SubmissionPagedResultDetailedResponse {
    /**  */
    "data"?: SubmissionPagedResult;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class SubmissionReportingRequest {
    /**  */
    @Expose()
    "userID"?: string;

    /**  */
    @Expose()
    "pageNumber"?: number;

    /**  */
    @Expose()
    "itemsPerPage"?: number;

    /**  */
    "searchString"?: string;

    /**  */
    "orderBy"?: string;

    /**  */
    "orderDirection"?: string;

    /**  */
    "startDate"?: string;

    /**  */
    "endDate"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "refrenceNumber"?: string;

    constructor(data: undefined | any = {}) {
        this["userID"] = data["userID"];
        this["pageNumber"] = data["pageNumber"];
        this["itemsPerPage"] = data["itemsPerPage"];
        this["searchString"] = data["searchString"];
        this["orderBy"] = data["orderBy"];
        this["orderDirection"] = data["orderDirection"];
        this["startDate"] = data["startDate"];
        this["endDate"] = data["endDate"];
        this["countyID"] = data["countyID"];
        this["ucn"] = data["ucn"];
        this["caseNumber"] = data["caseNumber"];
        this["refrenceNumber"] = data["refrenceNumber"];
    }

    public static validationModel = {};
}

export class SubmissionSearchResults {
    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "refrenceNumber"?: string;

    /**  */
    "countyName"?: string;

    /**  */
    "submissionStatus"?: string;

    /**  */
    "divisionName"?: string;

    /**  */
    "caseType"?: string;

    /**  */
    "portalStatus"?: string;

    constructor(data: undefined | any = {}) {
        this["submissionID"] = data["submissionID"];
        this["ucn"] = data["ucn"];
        this["caseNumber"] = data["caseNumber"];
        this["refrenceNumber"] = data["refrenceNumber"];
        this["countyName"] = data["countyName"];
        this["submissionStatus"] = data["submissionStatus"];
        this["divisionName"] = data["divisionName"];
        this["caseType"] = data["caseType"];
        this["portalStatus"] = data["portalStatus"];
    }

    public static validationModel = {};
}

export class SubmissionSearchResultsListDetailedResponse {
    /**  */
    "data"?: SubmissionSearchResults[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class TopManualFiles {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "count"?: number;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "fullName"?: string;

    /**  */
    "county"?: string;

    /**  */
    "documentType"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["count"] = data["count"];
        this["attorneyID"] = data["attorneyID"];
        this["fullName"] = data["fullName"];
        this["county"] = data["county"];
        this["documentType"] = data["documentType"];
    }

    public static validationModel = {};
}

export class TopManualFilesByDocType {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "updatedBy"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "uploadedDateTime"?: Date;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["filename"] = data["filename"];
        this["updatedBy"] = data["updatedBy"];
        this["uploadedDateTime"] = data["uploadedDateTime"];
    }

    public static validationModel = {};
}

export class TopManualFilesByDocTypeListDetailedResponse {
    /**  */
    "data"?: TopManualFilesByDocType[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class TopManualFilesByDocTypesRequest {
    /**  */
    @Expose()
    @Type(() => Date)
    "fromDateTime"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "toDateTime"?: Date;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "docType"?: string;

    /**  */
    "county"?: string;

    constructor(data: undefined | any = {}) {
        this["fromDateTime"] = data["fromDateTime"];
        this["toDateTime"] = data["toDateTime"];
        this["attorneyID"] = data["attorneyID"];
        this["docType"] = data["docType"];
        this["county"] = data["county"];
    }

    public static validationModel = {};
}

export class TopManualFilesListDetailedResponse {
    /**  */
    "data"?: TopManualFiles[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class TopManualFilesRequest {
    /**  */
    @Expose()
    @Type(() => Date)
    "fromDateTime"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "toDateTime"?: Date;

    constructor(data: undefined | any = {}) {
        this["fromDateTime"] = data["fromDateTime"];
        this["toDateTime"] = data["toDateTime"];
    }

    public static validationModel = {};
}

export class UpdateFeesRequest {
    /**  */
    "source"?: string;

    /**  */
    "fees"?: FeeLine[];

    constructor(data: undefined | any = {}) {
        this["source"] = data["source"];
        this["fees"] = data["fees"];
    }

    public static validationModel = {};
}

export class Upload {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "ip"?: string;

    /**  */
    @Expose()
    "totalDocuments"?: number;

    /**  */
    @Expose()
    "uploadedByID"?: string;

    /**  */
    "uploadedBy"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "uploadedDateTime"?: Date;

    /**  */
    "submitted"?: boolean;

    /**  */
    "cancelled"?: boolean;

    /**  */
    "cancelledBy"?: string;

    /**  */
    "fileHash"?: string;

    /**  */
    "fileAsIndividuals"?: boolean;

    /**  */
    "reason"?: string;

    /**  */
    "uploadedFiles"?: UploadedFile[];

    /**  */
    "caseData"?: CaseData;

    /**  */
    @Expose()
    "dataRows"?: number;

    /**  */
    "filingPartyResponsible"?: string;

    /**  */
    "eServiceOption"?: eServiceOptions;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["filename"] = data["filename"];
        this["ip"] = data["ip"];
        this["totalDocuments"] = data["totalDocuments"];
        this["uploadedByID"] = data["uploadedByID"];
        this["uploadedBy"] = data["uploadedBy"];
        this["uploadedDateTime"] = data["uploadedDateTime"];
        this["submitted"] = data["submitted"];
        this["cancelled"] = data["cancelled"];
        this["cancelledBy"] = data["cancelledBy"];
        this["fileHash"] = data["fileHash"];
        this["fileAsIndividuals"] = data["fileAsIndividuals"];
        this["reason"] = data["reason"];
        this["uploadedFiles"] = data["uploadedFiles"];
        this["caseData"] = data["caseData"];
        this["dataRows"] = data["dataRows"];
        this["filingPartyResponsible"] = data["filingPartyResponsible"];
        this["eServiceOption"] = data["eServiceOption"];
    }

    public static validationModel = {};
}

export class UploadCaseData {
    /**  */
    "ucn"?: string;

    /**  */
    "court"?: string;

    /**  */
    "county"?: string;

    /**  */
    "division"?: string;

    /**  */
    "caseType"?: string;

    /**  */
    "caseSubType"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "matterNumber"?: string;

    /**  */
    @Expose()
    "claimAmount"?: number;

    /**  */
    "parties"?: UploadParty[];

    constructor(data: undefined | any = {}) {
        this["ucn"] = data["ucn"];
        this["court"] = data["court"];
        this["county"] = data["county"];
        this["division"] = data["division"];
        this["caseType"] = data["caseType"];
        this["caseSubType"] = data["caseSubType"];
        this["caseNumber"] = data["caseNumber"];
        this["matterNumber"] = data["matterNumber"];
        this["claimAmount"] = data["claimAmount"];
        this["parties"] = data["parties"];
    }

    public static validationModel = {};
}

export class UploadIEnumerableDetailedResponse {
    /**  */
    "data"?: Upload[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class UploadPagedResult {
    /**  */
    "data"?: Upload[];

    /**  */
    @Expose()
    "totalCount"?: number;

    /**  */
    @Expose()
    "currentPage"?: number;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["totalCount"] = data["totalCount"];
        this["currentPage"] = data["currentPage"];
    }

    public static validationModel = {};
}

export class UploadParty {
    /**  */
    "partyType"?: string;

    /**  */
    "firstName"?: string;

    /**  */
    "middleName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "organization"?: string;

    /**  */
    "address"?: string;

    /**  */
    "address2"?: string;

    /**  */
    "city"?: string;

    /**  */
    "zip"?: string;

    /**  */
    "state"?: string;

    constructor(data: undefined | any = {}) {
        this["partyType"] = data["partyType"];
        this["firstName"] = data["firstName"];
        this["middleName"] = data["middleName"];
        this["lastName"] = data["lastName"];
        this["organization"] = data["organization"];
        this["address"] = data["address"];
        this["address2"] = data["address2"];
        this["city"] = data["city"];
        this["zip"] = data["zip"];
        this["state"] = data["state"];
    }

    public static validationModel = {};
}

export class UploadStatus {
    /**  */
    @Expose()
    "uploadId"?: string;

    /**  */
    "overallStatus"?: string;

    /**  */
    "reason"?: string;

    /**  */
    "uploadSubmissionStatuses"?: UploadSubmissionStatus[];

    constructor(data: undefined | any = {}) {
        this["uploadId"] = data["uploadId"];
        this["overallStatus"] = data["overallStatus"];
        this["reason"] = data["reason"];
        this["uploadSubmissionStatuses"] = data["uploadSubmissionStatuses"];
    }

    public static validationModel = {};
}

export class UploadStatusDetailedResponse {
    /**  */
    "data"?: UploadStatus;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class UploadSubmissionStatus {
    /**  */
    "fileName"?: string;

    /**  */
    "status"?: string;

    /**  */
    "clientMatterNumber"?: string;

    /**  */
    "referenceNumber"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    "reason"?: string;

    constructor(data: undefined | any = {}) {
        this["fileName"] = data["fileName"];
        this["status"] = data["status"];
        this["clientMatterNumber"] = data["clientMatterNumber"];
        this["referenceNumber"] = data["referenceNumber"];
        this["caseNumber"] = data["caseNumber"];
        this["ucn"] = data["ucn"];
        this["reason"] = data["reason"];
    }

    public static validationModel = {};
}

export class UploadedFile {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "uploadID"?: string;

    /**  */
    "filename"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["uploadID"] = data["uploadID"];
        this["filename"] = data["filename"];
    }

    public static validationModel = {};
}

export class V1File {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "fileID"?: number;

    /**  */
    @Expose()
    "process"?: number;

    /**  */
    "filename"?: string;

    /**  */
    "partyNames"?: string;

    /**  */
    "uniformCaseNumber"?: string;

    /**  */
    "clerkCaseNumber"?: string;

    /**  */
    "portalReferenceNumber"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["fileID"] = data["fileID"];
        this["process"] = data["process"];
        this["filename"] = data["filename"];
        this["partyNames"] = data["partyNames"];
        this["uniformCaseNumber"] = data["uniformCaseNumber"];
        this["clerkCaseNumber"] = data["clerkCaseNumber"];
        this["portalReferenceNumber"] = data["portalReferenceNumber"];
    }

    public static validationModel = {};
}

export class V1FileDetailedResponse {
    /**  */
    "data"?: V1File;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class V1FileListDetailedResponse {
    /**  */
    "data"?: V1File[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class V1InsertRequest {
    /**  */
    "folderName"?: string;

    /**  */
    "filename"?: string;

    /**  */
    @Expose()
    "fileSize"?: number;

    /**  */
    @Expose()
    "documentCount"?: number;

    /**  */
    "emergency"?: boolean;

    /**  */
    "confidential"?: boolean;

    constructor(data: undefined | any = {}) {
        this["folderName"] = data["folderName"];
        this["filename"] = data["filename"];
        this["fileSize"] = data["fileSize"];
        this["documentCount"] = data["documentCount"];
        this["emergency"] = data["emergency"];
        this["confidential"] = data["confidential"];
    }

    public static validationModel = {};
}

export class eFile {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "uploadTypeKey"?: number;

    /**  */
    @Expose()
    "userID"?: string;

    /**  */
    "submittedBy"?: string;

    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "attorneyName"?: string;

    /**  */
    "filename"?: string;

    /**  */
    "exhibits"?: Exhibits;

    /**  */
    "fileAsIndividuals"?: boolean;

    /**  */
    "caseData"?: UploadCaseData;

    /**  */
    "filenames"?: string[];

    /**  */
    "emergency"?: boolean;

    /**  */
    "matterNumber"?: string;

    /**  */
    "noEserve"?: boolean;

    /**  */
    "notes"?: string;

    /**  */
    "hasFees"?: boolean;

    /**  */
    "hasWaiver"?: boolean;

    /**  */
    @Expose()
    "serveWithSubmissionID"?: string;

    /**  */
    "filingParty"?: string;

    /**  */
    "flcEmail"?: string;

    /**  */
    @Expose()
    "eServiceOption"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["uploadTypeKey"] = data["uploadTypeKey"];
        this["userID"] = data["userID"];
        this["submittedBy"] = data["submittedBy"];
        this["attorneyID"] = data["attorneyID"];
        this["attorneyName"] = data["attorneyName"];
        this["filename"] = data["filename"];
        this["exhibits"] = data["exhibits"];
        this["fileAsIndividuals"] = data["fileAsIndividuals"];
        this["caseData"] = data["caseData"];
        this["filenames"] = data["filenames"];
        this["emergency"] = data["emergency"];
        this["matterNumber"] = data["matterNumber"];
        this["noEserve"] = data["noEserve"];
        this["notes"] = data["notes"];
        this["hasFees"] = data["hasFees"];
        this["hasWaiver"] = data["hasWaiver"];
        this["serveWithSubmissionID"] = data["serveWithSubmissionID"];
        this["filingParty"] = data["filingParty"];
        this["flcEmail"] = data["flcEmail"];
        this["eServiceOption"] = data["eServiceOption"];
    }

    public static validationModel = {};
}

export type DataTracReconcileAction = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type SubmissionReportFilterKeys = 1 | 2 | 4 | 8 | 16 | 32 | 64;

export type eServiceOptions = 1 | 2 | 3;
